(function() {
    'use strict';

    angular
        .module('publicGatewayApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', 'JhiTrackerService'];

    function Principal ($q, Account, JhiTrackerService) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
                JhiTrackerService.connect();
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset-password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset-password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change-password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage' ];

    function AuthServerProvider ($http, $localStorage ) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            });
        }

        function logout () {

            
            // logout from the server
            $http.post('api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/account');
                return response;
            });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'JhiTrackerService'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, JhiTrackerService) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    JhiTrackerService.sendActivity();
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {

            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {

            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Principal, LoginService, $state) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('SeekingSettingsDialogController', SeekingSettingsDialogController);

    SeekingSettingsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SeekingSettings', 'GenderEnum'];

    function SeekingSettingsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SeekingSettings, GenderEnum) {
        var vm = this;

        vm.seekingSettings = entity;
        vm.clear = clear;
        vm.save = save;
        vm.genderenums = GenderEnum.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.seekingSettings.id !== null) {
                SeekingSettings.update(vm.seekingSettings, onSaveSuccess, onSaveError);
            } else {
                SeekingSettings.save(vm.seekingSettings, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('publicGatewayApp:seekingSettingsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('SeekingSettingsDetailController', SeekingSettingsDetailController);

    SeekingSettingsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SeekingSettings', 'GenderEnum'];

    function SeekingSettingsDetailController($scope, $rootScope, $stateParams, previousState, entity, SeekingSettings, GenderEnum) {
        var vm = this;

        vm.seekingSettings = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('publicGatewayApp:seekingSettingsUpdate', function(event, result) {
            vm.seekingSettings = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('SeekingSettingsDeleteController',SeekingSettingsDeleteController);

    SeekingSettingsDeleteController.$inject = ['$uibModalInstance', 'entity', 'SeekingSettings'];

    function SeekingSettingsDeleteController($uibModalInstance, entity, SeekingSettings) {
        var vm = this;

        vm.seekingSettings = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SeekingSettings.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('seeking-settings', {
            parent: 'entity',
            url: '/seeking-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.seekingSettings.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/seeking-settings/seeking-settings.html',
                    controller: 'SeekingSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('seekingSettings');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('seeking-settings-detail', {
            parent: 'entity',
            url: '/seeking-settings/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.seekingSettings.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/seeking-settings/seeking-settings-detail.html',
                    controller: 'SeekingSettingsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('seekingSettings');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SeekingSettings', function($stateParams, SeekingSettings) {
                    return SeekingSettings.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'seeking-settings',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('seeking-settings-detail.edit', {
            parent: 'seeking-settings-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/seeking-settings/seeking-settings-dialog.html',
                    controller: 'SeekingSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SeekingSettings', function(SeekingSettings) {
                            return SeekingSettings.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('seeking-settings.new', {
            parent: 'seeking-settings',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/seeking-settings/seeking-settings-dialog.html',
                    controller: 'SeekingSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                ageFrom: null,
                                ageTo: null,
                                onlyFromMyMatches: null,
                                genderSet: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('seeking-settings', null, { reload: 'seeking-settings' });
                }, function() {
                    $state.go('seeking-settings');
                });
            }]
        })
        .state('seeking-settings.edit', {
            parent: 'seeking-settings',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/seeking-settings/seeking-settings-dialog.html',
                    controller: 'SeekingSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SeekingSettings', function(SeekingSettings) {
                            return SeekingSettings.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('seeking-settings', null, { reload: 'seeking-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('seeking-settings.delete', {
            parent: 'seeking-settings',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/seeking-settings/seeking-settings-delete-dialog.html',
                    controller: 'SeekingSettingsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SeekingSettings', function(SeekingSettings) {
                            return SeekingSettings.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('seeking-settings', null, { reload: 'seeking-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('SeekingSettings', SeekingSettings);

    SeekingSettings.$inject = ['$resource'];

    function SeekingSettings ($resource) {
        var resourceUrl =  'api/seeking-settings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('SeekingSettingsSearch', SeekingSettingsSearch);

    SeekingSettingsSearch.$inject = ['$resource'];

    function SeekingSettingsSearch($resource) {
        var resourceUrl =  'api/_search/seeking-settings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('SeekingSettingsController', SeekingSettingsController);

    SeekingSettingsController.$inject = ['$scope', '$state', 'SeekingSettings', 'SeekingSettingsSearch', 'ParseLinks', 'AlertService'];

    function SeekingSettingsController ($scope, $state, SeekingSettings, SeekingSettingsSearch, ParseLinks, AlertService) {
        var vm = this;
        
        vm.seekingSettings = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                SeekingSettingsSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                SeekingSettings.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.seekingSettings.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.seekingSettings = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.seekingSettings = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.seekingSettings = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('SeekingGenderDialogController', SeekingGenderDialogController);

    SeekingGenderDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SeekingGender'];

    function SeekingGenderDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SeekingGender) {
        var vm = this;

        vm.seekingGender = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.seekingGender.id !== null) {
                SeekingGender.update(vm.seekingGender, onSaveSuccess, onSaveError);
            } else {
                SeekingGender.save(vm.seekingGender, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('publicGatewayApp:seekingGenderUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('SeekingGenderDetailController', SeekingGenderDetailController);

    SeekingGenderDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SeekingGender'];

    function SeekingGenderDetailController($scope, $rootScope, $stateParams, previousState, entity, SeekingGender) {
        var vm = this;

        vm.seekingGender = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('publicGatewayApp:seekingGenderUpdate', function(event, result) {
            vm.seekingGender = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('SeekingGenderDeleteController',SeekingGenderDeleteController);

    SeekingGenderDeleteController.$inject = ['$uibModalInstance', 'entity', 'SeekingGender'];

    function SeekingGenderDeleteController($uibModalInstance, entity, SeekingGender) {
        var vm = this;

        vm.seekingGender = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SeekingGender.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('seeking-gender', {
            parent: 'entity',
            url: '/seeking-gender',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.seekingGender.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/seeking-gender/seeking-genders.html',
                    controller: 'SeekingGenderController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('seekingGender');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('seeking-gender-detail', {
            parent: 'entity',
            url: '/seeking-gender/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.seekingGender.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/seeking-gender/seeking-gender-detail.html',
                    controller: 'SeekingGenderDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('seekingGender');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SeekingGender', function($stateParams, SeekingGender) {
                    return SeekingGender.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'seeking-gender',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('seeking-gender-detail.edit', {
            parent: 'seeking-gender-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/seeking-gender/seeking-gender-dialog.html',
                    controller: 'SeekingGenderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SeekingGender', function(SeekingGender) {
                            return SeekingGender.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('seeking-gender.new', {
            parent: 'seeking-gender',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/seeking-gender/seeking-gender-dialog.html',
                    controller: 'SeekingGenderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                shortName: null,
                                title: null,
                                sortOrder: null,
                                enable: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('seeking-gender', null, { reload: 'seeking-gender' });
                }, function() {
                    $state.go('seeking-gender');
                });
            }]
        })
        .state('seeking-gender.edit', {
            parent: 'seeking-gender',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/seeking-gender/seeking-gender-dialog.html',
                    controller: 'SeekingGenderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SeekingGender', function(SeekingGender) {
                            return SeekingGender.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('seeking-gender', null, { reload: 'seeking-gender' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('seeking-gender.delete', {
            parent: 'seeking-gender',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/seeking-gender/seeking-gender-delete-dialog.html',
                    controller: 'SeekingGenderDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SeekingGender', function(SeekingGender) {
                            return SeekingGender.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('seeking-gender', null, { reload: 'seeking-gender' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('SeekingGender', SeekingGender);

    SeekingGender.$inject = ['$resource'];

    function SeekingGender ($resource) {
        var resourceUrl =  'api/seeking-genders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('SeekingGenderSearch', SeekingGenderSearch);

    SeekingGenderSearch.$inject = ['$resource'];

    function SeekingGenderSearch($resource) {
        var resourceUrl =  'api/_search/seeking-genders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('SeekingGenderController', SeekingGenderController);

    SeekingGenderController.$inject = ['$scope', '$state', 'SeekingGender', 'SeekingGenderSearch'];

    function SeekingGenderController ($scope, $state, SeekingGender, SeekingGenderSearch) {
        var vm = this;
        
        vm.seekingGenders = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            SeekingGender.query(function(result) {
                vm.seekingGenders = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            SeekingGenderSearch.query({query: vm.searchQuery}, function(result) {
                vm.seekingGenders = result;
            });
        }    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('RegionDialogController', RegionDialogController);

    RegionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Region'];

    function RegionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Region) {
        var vm = this;

        vm.region = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.region.id !== null) {
                Region.update(vm.region, onSaveSuccess, onSaveError);
            } else {
                Region.save(vm.region, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('publicGatewayApp:regionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('RegionDetailController', RegionDetailController);

    RegionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Region'];

    function RegionDetailController($scope, $rootScope, $stateParams, previousState, entity, Region) {
        var vm = this;

        vm.region = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('publicGatewayApp:regionUpdate', function(event, result) {
            vm.region = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('RegionDeleteController',RegionDeleteController);

    RegionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Region'];

    function RegionDeleteController($uibModalInstance, entity, Region) {
        var vm = this;

        vm.region = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Region.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('region', {
            parent: 'entity',
            url: '/region',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.region.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/region/regions.html',
                    controller: 'RegionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('region');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('region-detail', {
            parent: 'entity',
            url: '/region/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.region.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/region/region-detail.html',
                    controller: 'RegionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('region');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Region', function($stateParams, Region) {
                    return Region.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'region',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('region-detail.edit', {
            parent: 'region-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/region/region-dialog.html',
                    controller: 'RegionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Region', function(Region) {
                            return Region.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('region.new', {
            parent: 'region',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/region/region-dialog.html',
                    controller: 'RegionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                geonameId: null,
                                regionIsoCode: null,
                                regionName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('region', null, { reload: 'region' });
                }, function() {
                    $state.go('region');
                });
            }]
        })
        .state('region.edit', {
            parent: 'region',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/region/region-dialog.html',
                    controller: 'RegionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Region', function(Region) {
                            return Region.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('region', null, { reload: 'region' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('region.delete', {
            parent: 'region',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/region/region-delete-dialog.html',
                    controller: 'RegionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Region', function(Region) {
                            return Region.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('region', null, { reload: 'region' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('Region', Region);

    Region.$inject = ['$resource'];

    function Region ($resource) {
        var resourceUrl =  'api/regions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('RegionSearch', RegionSearch);

    RegionSearch.$inject = ['$resource'];

    function RegionSearch($resource) {
        var resourceUrl =  'api/_search/regions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('RegionController', RegionController);

    RegionController.$inject = ['$scope', '$state', 'Region', 'RegionSearch', 'ParseLinks', 'AlertService'];

    function RegionController ($scope, $state, Region, RegionSearch, ParseLinks, AlertService) {
        var vm = this;
        
        vm.regions = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                RegionSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Region.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.regions.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.regions = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.regions = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.regions = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('PublicProfileDialogController', PublicProfileDialogController);

    PublicProfileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'DataUtils', 'entity', 'PublicProfile', 'Gender', 'SeekingGender', 'Country', 'Region', 'City', 'Photo', 'SeekingSettings'];

    function PublicProfileDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, DataUtils, entity, PublicProfile, Gender, SeekingGender, Country, Region, City, Photo, SeekingSettings) {
        var vm = this;

        vm.publicProfile = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.genders = Gender.query();
        vm.seekinggenders = SeekingGender.query();
        vm.countries = Country.query();
        vm.regions = Region.query();
        vm.cities = City.query();
        vm.photos = Photo.query();
        vm.seekingsettings = SeekingSettings.query({filter: 'publicprofile-is-null'});
        $q.all([vm.publicProfile.$promise, vm.seekingsettings.$promise]).then(function() {
            if (!vm.publicProfile.seekingSettings || !vm.publicProfile.seekingSettings.id) {
                return $q.reject();
            }
            return SeekingSettings.get({id : vm.publicProfile.seekingSettings.id}).$promise;
        }).then(function(seekingSettings) {
            vm.seekingsettings.push(seekingSettings);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.publicProfile.id !== null) {
                PublicProfile.update(vm.publicProfile, onSaveSuccess, onSaveError);
            } else {
                PublicProfile.save(vm.publicProfile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('publicGatewayApp:publicProfileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setAvatar = function ($file, publicProfile) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        publicProfile.avatar = base64Data;
                        publicProfile.avatarContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('PublicProfileDetailController', PublicProfileDetailController);

    PublicProfileDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'PublicProfile', 'Gender', 'SeekingGender', 'Country', 'Region', 'City', 'Photo', 'SeekingSettings'];

    function PublicProfileDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, PublicProfile, Gender, SeekingGender, Country, Region, City, Photo, SeekingSettings) {
        var vm = this;

        vm.publicProfile = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('publicGatewayApp:publicProfileUpdate', function(event, result) {
            vm.publicProfile = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('PublicProfileDeleteController',PublicProfileDeleteController);

    PublicProfileDeleteController.$inject = ['$uibModalInstance', 'entity', 'PublicProfile'];

    function PublicProfileDeleteController($uibModalInstance, entity, PublicProfile) {
        var vm = this;

        vm.publicProfile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PublicProfile.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('public-profile', {
            parent: 'entity',
            url: '/public-profile',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.publicProfile.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-profile/public-profiles.html',
                    controller: 'PublicProfileController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicProfile');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('public-profile-detail', {
            parent: 'entity',
            url: '/public-profile/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.publicProfile.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-profile/public-profile-detail.html',
                    controller: 'PublicProfileDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicProfile');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PublicProfile', function($stateParams, PublicProfile) {
                    return PublicProfile.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'public-profile',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('public-profile-detail.edit', {
            parent: 'public-profile-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-profile/public-profile-dialog.html',
                    controller: 'PublicProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicProfile', function(PublicProfile) {
                            return PublicProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-profile.new', {
            parent: 'public-profile',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-profile/public-profile-dialog.html',
                    controller: 'PublicProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                version: null,
                                login: null,
                                title: null,
                                screenName: null,
                                screenNameStatus: null,
                                description: null,
                                descriptionStatus: null,
                                genderEnum: null,
                                age: null,
                                avatar: null,
                                avatarContentType: null,
                                originalUri: null,
                                largeUri: null,
                                mediumUri: null,
                                smallUri: null,
                                thumbnailUri: null,
                                photoCount: null,
                                videoCount: null,
                                online: false,
                                lastOnline: null,
                                status: null,
                                emailValidated: null,
                                confirmed: null,
                                paid: false,
                                premium: false,
                                interests: null,
                                tags: null,
                                preferredLanguage: null,
                                spokenLanguages: null,
                                rating: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('public-profile', null, { reload: 'public-profile' });
                }, function() {
                    $state.go('public-profile');
                });
            }]
        })
        .state('public-profile.edit', {
            parent: 'public-profile',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-profile/public-profile-dialog.html',
                    controller: 'PublicProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicProfile', function(PublicProfile) {
                            return PublicProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-profile', null, { reload: 'public-profile' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-profile.delete', {
            parent: 'public-profile',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-profile/public-profile-delete-dialog.html',
                    controller: 'PublicProfileDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PublicProfile', function(PublicProfile) {
                            return PublicProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-profile', null, { reload: 'public-profile' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('PublicProfile', PublicProfile);

    PublicProfile.$inject = ['$resource'];

    function PublicProfile ($resource) {
        var resourceUrl =  'api/public-profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('PublicProfileSearch', PublicProfileSearch);

    PublicProfileSearch.$inject = ['$resource'];

    function PublicProfileSearch($resource) {
        var resourceUrl =  'api/_search/public-profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('PublicProfileController', PublicProfileController);

    PublicProfileController.$inject = ['$scope', '$state', 'DataUtils', 'PublicProfile', 'PublicProfileSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function PublicProfileController ($scope, $state, DataUtils, PublicProfile, PublicProfileSearch, ParseLinks, AlertService, paginationConstants) {
        var vm = this;

        vm.publicProfiles = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                PublicProfileSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PublicProfile.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.publicProfiles.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.publicProfiles = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.publicProfiles = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.publicProfiles = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('ProfileCriterionItemDialogController', ProfileCriterionItemDialogController);

    ProfileCriterionItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProfileCriterionItem', 'ProfileCriterion'];

    function ProfileCriterionItemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProfileCriterionItem, ProfileCriterion) {
        var vm = this;

        vm.profileCriterionItem = entity;
        vm.clear = clear;
        vm.save = save;
        vm.profilecriteria = ProfileCriterion.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.profileCriterionItem.id !== null) {
                ProfileCriterionItem.update(vm.profileCriterionItem, onSaveSuccess, onSaveError);
            } else {
                ProfileCriterionItem.save(vm.profileCriterionItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('publicGatewayApp:profileCriterionItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('ProfileCriterionItemDetailController', ProfileCriterionItemDetailController);

    ProfileCriterionItemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProfileCriterionItem', 'ProfileCriterion'];

    function ProfileCriterionItemDetailController($scope, $rootScope, $stateParams, previousState, entity, ProfileCriterionItem, ProfileCriterion) {
        var vm = this;

        vm.profileCriterionItem = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('publicGatewayApp:profileCriterionItemUpdate', function(event, result) {
            vm.profileCriterionItem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('ProfileCriterionItemDeleteController',ProfileCriterionItemDeleteController);

    ProfileCriterionItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProfileCriterionItem'];

    function ProfileCriterionItemDeleteController($uibModalInstance, entity, ProfileCriterionItem) {
        var vm = this;

        vm.profileCriterionItem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProfileCriterionItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('profile-criterion-item', {
            parent: 'entity',
            url: '/profile-criterion-item',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.profileCriterionItem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profile-criterion-item/profile-criterion-items.html',
                    controller: 'ProfileCriterionItemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profileCriterionItem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('profile-criterion-item-detail', {
            parent: 'entity',
            url: '/profile-criterion-item/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.profileCriterionItem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profile-criterion-item/profile-criterion-item-detail.html',
                    controller: 'ProfileCriterionItemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profileCriterionItem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProfileCriterionItem', function($stateParams, ProfileCriterionItem) {
                    return ProfileCriterionItem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'profile-criterion-item',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('profile-criterion-item-detail.edit', {
            parent: 'profile-criterion-item-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile-criterion-item/profile-criterion-item-dialog.html',
                    controller: 'ProfileCriterionItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProfileCriterionItem', function(ProfileCriterionItem) {
                            return ProfileCriterionItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profile-criterion-item.new', {
            parent: 'profile-criterion-item',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile-criterion-item/profile-criterion-item-dialog.html',
                    controller: 'ProfileCriterionItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                shortName: null,
                                sortOrder: null,
                                enable: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('profile-criterion-item', null, { reload: 'profile-criterion-item' });
                }, function() {
                    $state.go('profile-criterion-item');
                });
            }]
        })
        .state('profile-criterion-item.edit', {
            parent: 'profile-criterion-item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile-criterion-item/profile-criterion-item-dialog.html',
                    controller: 'ProfileCriterionItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProfileCriterionItem', function(ProfileCriterionItem) {
                            return ProfileCriterionItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('profile-criterion-item', null, { reload: 'profile-criterion-item' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profile-criterion-item.delete', {
            parent: 'profile-criterion-item',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile-criterion-item/profile-criterion-item-delete-dialog.html',
                    controller: 'ProfileCriterionItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProfileCriterionItem', function(ProfileCriterionItem) {
                            return ProfileCriterionItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('profile-criterion-item', null, { reload: 'profile-criterion-item' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('ProfileCriterionItem', ProfileCriterionItem);

    ProfileCriterionItem.$inject = ['$resource'];

    function ProfileCriterionItem ($resource) {
        var resourceUrl =  'api/profile-criterion-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('ProfileCriterionItemSearch', ProfileCriterionItemSearch);

    ProfileCriterionItemSearch.$inject = ['$resource'];

    function ProfileCriterionItemSearch($resource) {
        var resourceUrl =  'api/_search/profile-criterion-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('ProfileCriterionItemController', ProfileCriterionItemController);

    ProfileCriterionItemController.$inject = ['$scope', '$state', 'ProfileCriterionItem', 'ProfileCriterionItemSearch'];

    function ProfileCriterionItemController ($scope, $state, ProfileCriterionItem, ProfileCriterionItemSearch) {
        var vm = this;

        vm.profileCriterionItems = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            ProfileCriterionItem.query(function(result) {
                vm.profileCriterionItems = result;
                vm.searchQuery = null;
            });
        }

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ProfileCriterionItemSearch.query({query: vm.searchQuery}, function(result) {
                vm.profileCriterionItems = result;
                vm.currentSearch = vm.searchQuery;
            });
        }

        function clear() {
            vm.searchQuery = null;
            loadAll();
        }    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('ProfileCriterionDialogController', ProfileCriterionDialogController);

    ProfileCriterionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProfileCriterion', 'ProfileCriterionItem'];

    function ProfileCriterionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProfileCriterion, ProfileCriterionItem) {
        var vm = this;

        vm.profileCriterion = entity;
        vm.clear = clear;
        vm.save = save;
        vm.profilecriterionitems = ProfileCriterionItem.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.profileCriterion.id !== null) {
                ProfileCriterion.update(vm.profileCriterion, onSaveSuccess, onSaveError);
            } else {
                ProfileCriterion.save(vm.profileCriterion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('publicGatewayApp:profileCriterionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('ProfileCriterionDetailController', ProfileCriterionDetailController);

    ProfileCriterionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProfileCriterion', 'ProfileCriterionItem'];

    function ProfileCriterionDetailController($scope, $rootScope, $stateParams, previousState, entity, ProfileCriterion, ProfileCriterionItem) {
        var vm = this;

        vm.profileCriterion = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('publicGatewayApp:profileCriterionUpdate', function(event, result) {
            vm.profileCriterion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('ProfileCriterionDeleteController',ProfileCriterionDeleteController);

    ProfileCriterionDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProfileCriterion'];

    function ProfileCriterionDeleteController($uibModalInstance, entity, ProfileCriterion) {
        var vm = this;

        vm.profileCriterion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProfileCriterion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('profile-criterion', {
            parent: 'entity',
            url: '/profile-criterion',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.profileCriterion.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profile-criterion/profile-criteria.html',
                    controller: 'ProfileCriterionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profileCriterion');
                    $translatePartialLoader.addPart('profileCriterionType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('profile-criterion-detail', {
            parent: 'entity',
            url: '/profile-criterion/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.profileCriterion.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profile-criterion/profile-criterion-detail.html',
                    controller: 'ProfileCriterionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profileCriterion');
                    $translatePartialLoader.addPart('profileCriterionType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProfileCriterion', function($stateParams, ProfileCriterion) {
                    return ProfileCriterion.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'profile-criterion',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('profile-criterion-detail.edit', {
            parent: 'profile-criterion-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile-criterion/profile-criterion-dialog.html',
                    controller: 'ProfileCriterionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProfileCriterion', function(ProfileCriterion) {
                            return ProfileCriterion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profile-criterion.new', {
            parent: 'profile-criterion',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile-criterion/profile-criterion-dialog.html',
                    controller: 'ProfileCriterionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                shortName: null,
                                sortOrder: null,
                                enable: null,
                                type: null,
                                measurementUnitName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('profile-criterion', null, { reload: 'profile-criterion' });
                }, function() {
                    $state.go('profile-criterion');
                });
            }]
        })
        .state('profile-criterion.edit', {
            parent: 'profile-criterion',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile-criterion/profile-criterion-dialog.html',
                    controller: 'ProfileCriterionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProfileCriterion', function(ProfileCriterion) {
                            return ProfileCriterion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('profile-criterion', null, { reload: 'profile-criterion' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profile-criterion.delete', {
            parent: 'profile-criterion',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile-criterion/profile-criterion-delete-dialog.html',
                    controller: 'ProfileCriterionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProfileCriterion', function(ProfileCriterion) {
                            return ProfileCriterion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('profile-criterion', null, { reload: 'profile-criterion' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('ProfileCriterion', ProfileCriterion);

    ProfileCriterion.$inject = ['$resource'];

    function ProfileCriterion ($resource) {
        var resourceUrl =  'api/profile-criteria/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('ProfileCriterionSearch', ProfileCriterionSearch);

    ProfileCriterionSearch.$inject = ['$resource'];

    function ProfileCriterionSearch($resource) {
        var resourceUrl =  'api/_search/profile-criteria/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('ProfileCriterionController', ProfileCriterionController);

    ProfileCriterionController.$inject = ['$scope', '$state', 'ProfileCriterion', 'ProfileCriterionSearch'];

    function ProfileCriterionController ($scope, $state, ProfileCriterion, ProfileCriterionSearch) {
        var vm = this;

        vm.profileCriteria = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            ProfileCriterion.query(function(result) {
                vm.profileCriteria = result;
                vm.searchQuery = null;
            });
        }

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ProfileCriterionSearch.query({query: vm.searchQuery}, function(result) {
                vm.profileCriteria = result;
                vm.currentSearch = vm.searchQuery;
            });
        }

        function clear() {
            vm.searchQuery = null;
            loadAll();
        }    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('PhotoDialogController', PhotoDialogController);

    PhotoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Photo', 'PublicProfile'];

    function PhotoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Photo, PublicProfile) {
        var vm = this;

        vm.photo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.publicprofiles = PublicProfile.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.photo.id !== null) {
                Photo.update(vm.photo, onSaveSuccess, onSaveError);
            } else {
                Photo.save(vm.photo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('publicGatewayApp:photoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('PhotoDetailController', PhotoDetailController);

    PhotoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Photo', 'PublicProfile'];

    function PhotoDetailController($scope, $rootScope, $stateParams, previousState, entity, Photo, PublicProfile) {
        var vm = this;

        vm.photo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('publicGatewayApp:photoUpdate', function(event, result) {
            vm.photo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('PhotoDeleteController',PhotoDeleteController);

    PhotoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Photo'];

    function PhotoDeleteController($uibModalInstance, entity, Photo) {
        var vm = this;

        vm.photo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Photo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('photo', {
            parent: 'entity',
            url: '/photo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.photo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/photo/photos.html',
                    controller: 'PhotoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('photo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('photo-detail', {
            parent: 'entity',
            url: '/photo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.photo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/photo/photo-detail.html',
                    controller: 'PhotoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('photo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Photo', function($stateParams, Photo) {
                    return Photo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'photo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('photo-detail.edit', {
            parent: 'photo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/photo/photo-dialog.html',
                    controller: 'PhotoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Photo', function(Photo) {
                            return Photo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('photo.new', {
            parent: 'photo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/photo/photo-dialog.html',
                    controller: 'PhotoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                originalUri: null,
                                largeUri: null,
                                mediumUri: null,
                                smallUri: null,
                                thumbnailUri: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('photo', null, { reload: 'photo' });
                }, function() {
                    $state.go('photo');
                });
            }]
        })
        .state('photo.edit', {
            parent: 'photo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/photo/photo-dialog.html',
                    controller: 'PhotoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Photo', function(Photo) {
                            return Photo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('photo', null, { reload: 'photo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('photo.delete', {
            parent: 'photo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/photo/photo-delete-dialog.html',
                    controller: 'PhotoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Photo', function(Photo) {
                            return Photo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('photo', null, { reload: 'photo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('Photo', Photo);

    Photo.$inject = ['$resource'];

    function Photo ($resource) {
        var resourceUrl =  'api/photos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('PhotoSearch', PhotoSearch);

    PhotoSearch.$inject = ['$resource'];

    function PhotoSearch($resource) {
        var resourceUrl =  'api/_search/photos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('PhotoController', PhotoController);

    PhotoController.$inject = ['$scope', '$state', 'Photo', 'PhotoSearch'];

    function PhotoController ($scope, $state, Photo, PhotoSearch) {
        var vm = this;
        
        vm.photos = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            Photo.query(function(result) {
                vm.photos = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            PhotoSearch.query({query: vm.searchQuery}, function(result) {
                vm.photos = result;
            });
        }    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('OwnProfileDialogController', OwnProfileDialogController);

    OwnProfileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OwnProfile'];

    function OwnProfileDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OwnProfile) {
        var vm = this;

        vm.ownProfile = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ownProfile.id !== null) {
                OwnProfile.update(vm.ownProfile, onSaveSuccess, onSaveError);
            } else {
                OwnProfile.save(vm.ownProfile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('publicGatewayApp:ownProfileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dob = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('OwnProfileDetailController', OwnProfileDetailController);

    OwnProfileDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'OwnProfile'];

    function OwnProfileDetailController($scope, $rootScope, $stateParams, previousState, entity, OwnProfile) {
        var vm = this;

        vm.ownProfile = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('publicGatewayApp:ownProfileUpdate', function(event, result) {
            vm.ownProfile = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('OwnProfileDeleteController',OwnProfileDeleteController);

    OwnProfileDeleteController.$inject = ['$uibModalInstance', 'entity', 'OwnProfile'];

    function OwnProfileDeleteController($uibModalInstance, entity, OwnProfile) {
        var vm = this;

        vm.ownProfile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            OwnProfile.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('own-profile', {
            parent: 'entity',
            url: '/own-profile',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.ownProfile.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/own-profile/own-profiles.html',
                    controller: 'OwnProfileController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ownProfile');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('own-profile-detail', {
            parent: 'entity',
            url: '/own-profile/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.ownProfile.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/own-profile/own-profile-detail.html',
                    controller: 'OwnProfileDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ownProfile');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OwnProfile', function($stateParams, OwnProfile) {
                    return OwnProfile.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'own-profile',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('own-profile-detail.edit', {
            parent: 'own-profile-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/own-profile/own-profile-dialog.html',
                    controller: 'OwnProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OwnProfile', function(OwnProfile) {
                            return OwnProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('own-profile.new', {
            parent: 'own-profile',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/own-profile/own-profile-dialog.html',
                    controller: 'OwnProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                screenName: null,
                                age: null,
                                dob: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('own-profile', null, { reload: true });
                }, function() {
                    $state.go('own-profile');
                });
            }]
        })
        .state('own-profile.edit', {
            parent: 'own-profile',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/own-profile/own-profile-dialog.html',
                    controller: 'OwnProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OwnProfile', function(OwnProfile) {
                            return OwnProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('own-profile', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('own-profile.delete', {
            parent: 'own-profile',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/own-profile/own-profile-delete-dialog.html',
                    controller: 'OwnProfileDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OwnProfile', function(OwnProfile) {
                            return OwnProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('own-profile', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('OwnProfile', OwnProfile);

    OwnProfile.$inject = ['$resource', 'DateUtils'];

    function OwnProfile ($resource, DateUtils) {
        var resourceUrl =  'api/own-profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dob = DateUtils.convertLocalDateFromServer(data.dob);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.dob = DateUtils.convertLocalDateToServer(data.dob);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.dob = DateUtils.convertLocalDateToServer(data.dob);
                    return angular.toJson(data);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('OwnProfileSearch', OwnProfileSearch);

    OwnProfileSearch.$inject = ['$resource'];

    function OwnProfileSearch($resource) {
        var resourceUrl =  'api/_search/own-profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('OwnProfileController', OwnProfileController);

    OwnProfileController.$inject = ['$scope', '$state', 'OwnProfile', 'OwnProfileSearch', 'ParseLinks', 'AlertService'];

    function OwnProfileController ($scope, $state, OwnProfile, OwnProfileSearch, ParseLinks, AlertService) {
        var vm = this;
        
        vm.ownProfiles = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                OwnProfileSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                OwnProfile.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.ownProfiles.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.ownProfiles = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.ownProfiles = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.ownProfiles = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('LocationDialogController', LocationDialogController);

    LocationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Location', 'Country', 'Region', 'City'];

    function LocationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Location, Country, Region, City) {
        var vm = this;

        vm.location = entity;
        vm.clear = clear;
        vm.save = save;
        vm.countries = Country.query();
        vm.regions = Region.query();
        vm.cities = City.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.location.id !== null) {
                Location.update(vm.location, onSaveSuccess, onSaveError);
            } else {
                Location.save(vm.location, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('publicGatewayApp:locationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('LocationDetailController', LocationDetailController);

    LocationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Location', 'Country', 'Region', 'City'];

    function LocationDetailController($scope, $rootScope, $stateParams, previousState, entity, Location, Country, Region, City) {
        var vm = this;

        vm.location = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('publicGatewayApp:locationUpdate', function(event, result) {
            vm.location = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('LocationDeleteController',LocationDeleteController);

    LocationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Location'];

    function LocationDeleteController($uibModalInstance, entity, Location) {
        var vm = this;

        vm.location = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Location.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('location', {
            parent: 'entity',
            url: '/location',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.location.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/location/locations.html',
                    controller: 'LocationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('location');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('location-detail', {
            parent: 'entity',
            url: '/location/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.location.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/location/location-detail.html',
                    controller: 'LocationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('location');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Location', function($stateParams, Location) {
                    return Location.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'location',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('location-detail.edit', {
            parent: 'location-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/location/location-dialog.html',
                    controller: 'LocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Location', function(Location) {
                            return Location.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('location.new', {
            parent: 'location',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/location/location-dialog.html',
                    controller: 'LocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                cityName: null,
                                internalName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('location', null, { reload: 'location' });
                }, function() {
                    $state.go('location');
                });
            }]
        })
        .state('location.edit', {
            parent: 'location',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/location/location-dialog.html',
                    controller: 'LocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Location', function(Location) {
                            return Location.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('location', null, { reload: 'location' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('location.delete', {
            parent: 'location',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/location/location-delete-dialog.html',
                    controller: 'LocationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Location', function(Location) {
                            return Location.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('location', null, { reload: 'location' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('Location', Location);

    Location.$inject = ['$resource'];

    function Location ($resource) {
        var resourceUrl =  'api/locations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('LocationSearch', LocationSearch);

    LocationSearch.$inject = ['$resource'];

    function LocationSearch($resource) {
        var resourceUrl =  'api/_search/locations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('LocationController', LocationController);

    LocationController.$inject = ['$scope', '$state', 'Location', 'LocationSearch', 'ParseLinks', 'AlertService'];

    function LocationController ($scope, $state, Location, LocationSearch, ParseLinks, AlertService) {
        var vm = this;
        
        vm.locations = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                LocationSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Location.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.locations.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.locations = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.locations = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.locations = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('LanguageDialogController', LanguageDialogController);

    LanguageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Language'];

    function LanguageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Language) {
        var vm = this;

        vm.language = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.language.id !== null) {
                Language.update(vm.language, onSaveSuccess, onSaveError);
            } else {
                Language.save(vm.language, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('publicGatewayApp:languageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('LanguageDetailController', LanguageDetailController);

    LanguageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Language'];

    function LanguageDetailController($scope, $rootScope, $stateParams, previousState, entity, Language) {
        var vm = this;

        vm.language = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('publicGatewayApp:languageUpdate', function(event, result) {
            vm.language = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('LanguageDeleteController',LanguageDeleteController);

    LanguageDeleteController.$inject = ['$uibModalInstance', 'entity', 'Language'];

    function LanguageDeleteController($uibModalInstance, entity, Language) {
        var vm = this;

        vm.language = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Language.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('language', {
            parent: 'entity',
            url: '/language',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.language.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/language/languages.html',
                    controller: 'LanguageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('language');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('language-detail', {
            parent: 'entity',
            url: '/language/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.language.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/language/language-detail.html',
                    controller: 'LanguageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('language');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Language', function($stateParams, Language) {
                    return Language.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'language',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('language-detail.edit', {
            parent: 'language-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/language/language-dialog.html',
                    controller: 'LanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Language', function(Language) {
                            return Language.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('language.new', {
            parent: 'language',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/language/language-dialog.html',
                    controller: 'LanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                shortName: null,
                                sortOrder: null,
                                enable: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('language', null, { reload: 'language' });
                }, function() {
                    $state.go('language');
                });
            }]
        })
        .state('language.edit', {
            parent: 'language',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/language/language-dialog.html',
                    controller: 'LanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Language', function(Language) {
                            return Language.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('language', null, { reload: 'language' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('language.delete', {
            parent: 'language',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/language/language-delete-dialog.html',
                    controller: 'LanguageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Language', function(Language) {
                            return Language.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('language', null, { reload: 'language' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('Language', Language);

    Language.$inject = ['$resource'];

    function Language ($resource) {
        var resourceUrl =  'api/languages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('LanguageSearch', LanguageSearch);

    LanguageSearch.$inject = ['$resource'];

    function LanguageSearch($resource) {
        var resourceUrl =  'api/_search/languages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('LanguageController', LanguageController);

    LanguageController.$inject = ['$scope', '$state', 'Language', 'LanguageSearch'];

    function LanguageController ($scope, $state, Language, LanguageSearch) {
        var vm = this;
        
        vm.languages = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            Language.query(function(result) {
                vm.languages = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            LanguageSearch.query({query: vm.searchQuery}, function(result) {
                vm.languages = result;
            });
        }    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('GeonameLocalizationDialogController', GeonameLocalizationDialogController);

    GeonameLocalizationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'GeonameLocalization'];

    function GeonameLocalizationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, GeonameLocalization) {
        var vm = this;

        vm.geonameLocalization = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.geonameLocalization.id !== null) {
                GeonameLocalization.update(vm.geonameLocalization, onSaveSuccess, onSaveError);
            } else {
                GeonameLocalization.save(vm.geonameLocalization, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('publicGatewayApp:geonameLocalizationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('GeonameLocalizationDetailController', GeonameLocalizationDetailController);

    GeonameLocalizationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'GeonameLocalization'];

    function GeonameLocalizationDetailController($scope, $rootScope, $stateParams, previousState, entity, GeonameLocalization) {
        var vm = this;

        vm.geonameLocalization = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('publicGatewayApp:geonameLocalizationUpdate', function(event, result) {
            vm.geonameLocalization = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('GeonameLocalizationDeleteController',GeonameLocalizationDeleteController);

    GeonameLocalizationDeleteController.$inject = ['$uibModalInstance', 'entity', 'GeonameLocalization'];

    function GeonameLocalizationDeleteController($uibModalInstance, entity, GeonameLocalization) {
        var vm = this;

        vm.geonameLocalization = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            GeonameLocalization.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('geoname-localization', {
            parent: 'entity',
            url: '/geoname-localization',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.geonameLocalization.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/geoname-localization/geoname-localizations.html',
                    controller: 'GeonameLocalizationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('geonameLocalization');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('geoname-localization-detail', {
            parent: 'geoname-localization',
            url: '/geoname-localization/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.geonameLocalization.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/geoname-localization/geoname-localization-detail.html',
                    controller: 'GeonameLocalizationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('geonameLocalization');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GeonameLocalization', function($stateParams, GeonameLocalization) {
                    return GeonameLocalization.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'geoname-localization',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('geoname-localization-detail.edit', {
            parent: 'geoname-localization-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/geoname-localization/geoname-localization-dialog.html',
                    controller: 'GeonameLocalizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GeonameLocalization', function(GeonameLocalization) {
                            return GeonameLocalization.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('geoname-localization.new', {
            parent: 'geoname-localization',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/geoname-localization/geoname-localization-dialog.html',
                    controller: 'GeonameLocalizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                geonameId: null,
                                language: null,
                                name: null,
                                isPreferredName: null,
                                isShortName: null,
                                isColloquial: null,
                                isHistoric: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('geoname-localization', null, { reload: 'geoname-localization' });
                }, function() {
                    $state.go('geoname-localization');
                });
            }]
        })
        .state('geoname-localization.edit', {
            parent: 'geoname-localization',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/geoname-localization/geoname-localization-dialog.html',
                    controller: 'GeonameLocalizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GeonameLocalization', function(GeonameLocalization) {
                            return GeonameLocalization.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('geoname-localization', null, { reload: 'geoname-localization' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('geoname-localization.delete', {
            parent: 'geoname-localization',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/geoname-localization/geoname-localization-delete-dialog.html',
                    controller: 'GeonameLocalizationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GeonameLocalization', function(GeonameLocalization) {
                            return GeonameLocalization.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('geoname-localization', null, { reload: 'geoname-localization' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('GeonameLocalization', GeonameLocalization);

    GeonameLocalization.$inject = ['$resource'];

    function GeonameLocalization ($resource) {
        var resourceUrl =  'api/geoname-localizations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('GeonameLocalizationSearch', GeonameLocalizationSearch);

    GeonameLocalizationSearch.$inject = ['$resource'];

    function GeonameLocalizationSearch($resource) {
        var resourceUrl =  'api/_search/geoname-localizations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('GeonameLocalizationController', GeonameLocalizationController);

    GeonameLocalizationController.$inject = ['GeonameLocalization', 'GeonameLocalizationSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function GeonameLocalizationController(GeonameLocalization, GeonameLocalizationSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.geonameLocalizations = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                GeonameLocalizationSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                GeonameLocalization.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.geonameLocalizations.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.geonameLocalizations = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.geonameLocalizations = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.geonameLocalizations = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('GenderDialogController', GenderDialogController);

    GenderDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Gender'];

    function GenderDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Gender) {
        var vm = this;

        vm.gender = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.gender.id !== null) {
                Gender.update(vm.gender, onSaveSuccess, onSaveError);
            } else {
                Gender.save(vm.gender, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('publicGatewayApp:genderUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('GenderDetailController', GenderDetailController);

    GenderDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Gender'];

    function GenderDetailController($scope, $rootScope, $stateParams, previousState, entity, Gender) {
        var vm = this;

        vm.gender = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('publicGatewayApp:genderUpdate', function(event, result) {
            vm.gender = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('GenderDeleteController',GenderDeleteController);

    GenderDeleteController.$inject = ['$uibModalInstance', 'entity', 'Gender'];

    function GenderDeleteController($uibModalInstance, entity, Gender) {
        var vm = this;

        vm.gender = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Gender.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('gender', {
            parent: 'entity',
            url: '/gender',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.gender.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gender/genders.html',
                    controller: 'GenderController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gender');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('gender-detail', {
            parent: 'entity',
            url: '/gender/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.gender.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gender/gender-detail.html',
                    controller: 'GenderDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gender');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Gender', function($stateParams, Gender) {
                    return Gender.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'gender',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('gender-detail.edit', {
            parent: 'gender-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gender/gender-dialog.html',
                    controller: 'GenderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Gender', function(Gender) {
                            return Gender.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('gender.new', {
            parent: 'gender',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gender/gender-dialog.html',
                    controller: 'GenderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                shortName: null,
                                title: null,
                                sortOrder: null,
                                enable: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('gender', null, { reload: 'gender' });
                }, function() {
                    $state.go('gender');
                });
            }]
        })
        .state('gender.edit', {
            parent: 'gender',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gender/gender-dialog.html',
                    controller: 'GenderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Gender', function(Gender) {
                            return Gender.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('gender', null, { reload: 'gender' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('gender.delete', {
            parent: 'gender',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gender/gender-delete-dialog.html',
                    controller: 'GenderDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Gender', function(Gender) {
                            return Gender.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('gender', null, { reload: 'gender' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('Gender', Gender);

    Gender.$inject = ['$resource'];

    function Gender ($resource) {
        var resourceUrl =  'api/genders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('GenderSearch', GenderSearch);

    GenderSearch.$inject = ['$resource'];

    function GenderSearch($resource) {
        var resourceUrl =  'api/_search/genders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('GenderController', GenderController);

    GenderController.$inject = ['$scope', '$state', 'Gender', 'GenderSearch'];

    function GenderController ($scope, $state, Gender, GenderSearch) {
        var vm = this;
        
        vm.genders = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            Gender.query(function(result) {
                vm.genders = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            GenderSearch.query({query: vm.searchQuery}, function(result) {
                vm.genders = result;
            });
        }    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('CountryDialogController', CountryDialogController);

    CountryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Country'];

    function CountryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Country) {
        var vm = this;

        vm.country = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.country.id !== null) {
                Country.update(vm.country, onSaveSuccess, onSaveError);
            } else {
                Country.save(vm.country, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('publicGatewayApp:countryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('CountryDetailController', CountryDetailController);

    CountryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Country'];

    function CountryDetailController($scope, $rootScope, $stateParams, previousState, entity, Country) {
        var vm = this;

        vm.country = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('publicGatewayApp:countryUpdate', function(event, result) {
            vm.country = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('CountryDeleteController',CountryDeleteController);

    CountryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Country'];

    function CountryDeleteController($uibModalInstance, entity, Country) {
        var vm = this;

        vm.country = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Country.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('country', {
            parent: 'entity',
            url: '/country',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.country.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country/countries.html',
                    controller: 'CountryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('country');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('country-detail', {
            parent: 'entity',
            url: '/country/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.country.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country/country-detail.html',
                    controller: 'CountryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('country');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Country', function($stateParams, Country) {
                    return Country.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'country',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('country-detail.edit', {
            parent: 'country-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('country.new', {
            parent: 'country',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                geonameId: null,
                                localeCode: null,
                                continentCode: null,
                                continentName: null,
                                countryIsoCode: null,
                                countryName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: 'country' });
                }, function() {
                    $state.go('country');
                });
            }]
        })
        .state('country.edit', {
            parent: 'country',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: 'country' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('country.delete', {
            parent: 'country',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-delete-dialog.html',
                    controller: 'CountryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: 'country' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('Country', Country);

    Country.$inject = ['$resource'];

    function Country ($resource) {
        var resourceUrl =  'api/countries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('CountrySearch', CountrySearch);

    CountrySearch.$inject = ['$resource'];

    function CountrySearch($resource) {
        var resourceUrl =  'api/_search/countries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('CountryController', CountryController);

    CountryController.$inject = ['$scope', '$state', 'Country', 'CountrySearch', 'ParseLinks', 'AlertService'];

    function CountryController ($scope, $state, Country, CountrySearch, ParseLinks, AlertService) {
        var vm = this;
        
        vm.countries = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                CountrySearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Country.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.countries.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.countries = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.countries = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.countries = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('CityDialogController', CityDialogController);

    CityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'City'];

    function CityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, City) {
        var vm = this;

        vm.city = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.city.id !== null) {
                City.update(vm.city, onSaveSuccess, onSaveError);
            } else {
                City.save(vm.city, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('publicGatewayApp:cityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.modificationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('CityDetailController', CityDetailController);

    CityDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'City'];

    function CityDetailController($scope, $rootScope, $stateParams, previousState, entity, City) {
        var vm = this;

        vm.city = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('publicGatewayApp:cityUpdate', function(event, result) {
            vm.city = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('CityDeleteController',CityDeleteController);

    CityDeleteController.$inject = ['$uibModalInstance', 'entity', 'City'];

    function CityDeleteController($uibModalInstance, entity, City) {
        var vm = this;

        vm.city = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            City.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('city', {
            parent: 'entity',
            url: '/city',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.city.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/city/cities.html',
                    controller: 'CityController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('city');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('city-detail', {
            parent: 'entity',
            url: '/city/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.city.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/city/city-detail.html',
                    controller: 'CityDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('city');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'City', function($stateParams, City) {
                    return City.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'city',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('city-detail.edit', {
            parent: 'city-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/city/city-dialog.html',
                    controller: 'CityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['City', function(City) {
                            return City.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('city.new', {
            parent: 'city',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/city/city-dialog.html',
                    controller: 'CityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                geonameId: null,
                                name: null,
                                asciiName: null,
                                alternateNames: null,
                                latitude: null,
                                longitude: null,
                                featureClass: null,
                                featureCode: null,
                                countryCode: null,
                                cc2: null,
                                admin1Code: null,
                                admin2Code: null,
                                admin3Code: null,
                                admin4Code: null,
                                population: null,
                                elevation: null,
                                dem: null,
                                timezone: null,
                                modificationDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('city', null, { reload: 'city' });
                }, function() {
                    $state.go('city');
                });
            }]
        })
        .state('city.edit', {
            parent: 'city',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/city/city-dialog.html',
                    controller: 'CityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['City', function(City) {
                            return City.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('city', null, { reload: 'city' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('city.delete', {
            parent: 'city',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/city/city-delete-dialog.html',
                    controller: 'CityDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['City', function(City) {
                            return City.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('city', null, { reload: 'city' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('City', City);

    City.$inject = ['$resource', 'DateUtils'];

    function City ($resource, DateUtils) {
        var resourceUrl =  'api/cities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.modificationDate = DateUtils.convertLocalDateFromServer(data.modificationDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.modificationDate = DateUtils.convertLocalDateToServer(copy.modificationDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.modificationDate = DateUtils.convertLocalDateToServer(copy.modificationDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('CitySearch', CitySearch);

    CitySearch.$inject = ['$resource'];

    function CitySearch($resource) {
        var resourceUrl =  'api/_search/cities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('CityController', CityController);

    CityController.$inject = ['$scope', '$state', 'City', 'CitySearch', 'ParseLinks', 'AlertService'];

    function CityController ($scope, $state, City, CitySearch, ParseLinks, AlertService) {
        var vm = this;
        
        vm.cities = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                CitySearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                City.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.cities.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.cities = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.cities = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.cities = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info" data-translate="global.item-count" ' +
        'translate-value-first="{{(($ctrl.page - 1) * $ctrl.itemsPerPage) === 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}}" ' +
        'translate-value-second="{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}}" ' +
        'translate-value-total="{{$ctrl.queryCount}}">' +
        'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
        '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
        'of {{$ctrl.queryCount}} items.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('publicGatewayApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .constant('errorConstants', (function() {
            var problemBaseUrl = 'http://www.jhipster.tech/problem';
            return {
                EMAIL_ALREADY_USED_TYPE: problemBaseUrl + '/email-already-used',
                LOGIN_ALREADY_USED_TYPE: problemBaseUrl + '/login-already-used',
                EMAIL_NOT_FOUND_TYPE: problemBaseUrl + '/email-not-found'
            }
        })());
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .filter('findLanguageFromKey', findLanguageFromKey)
        .filter('findLanguageRtlFromKey', findLanguageRtlFromKey);

    var languages = {
        'en': { name: 'English' },
        'it': { name: 'Italiano' }
        // jhipster-needle-i18n-language-key-pipe - JHipster will add/remove languages in this object
    };

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return languages[lang].name;
        }
    }

    function findLanguageRtlFromKey() {
        return findLanguageRtlFromKeyFilter;

        function findLanguageRtlFromKeyFilter(lang) {
            return languages[lang].rtl;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('publicGatewayApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'it'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('publicGatewayApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('publicGatewayApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (angular.isString(errorHeader)) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('publicGatewayApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('publicGatewayApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('publicGatewayApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            if (!config || !config.url || /^http/.test(config.url)) return config;

            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }


        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider', 'BUILD_TIMESTAMP'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider, BUILD_TIMESTAMP) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json' + (BUILD_TIMESTAMP ? '?build=' + BUILD_TIMESTAMP : '')
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('publicGatewayApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1773141086418)
;
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-tracker', {
            parent: 'admin',
            url: '/tracker',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tracker.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/tracker/tracker.html',
                    controller: 'JhiTrackerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tracker');
                    return $translate.refresh();
                }]
            },
            onEnter: ['JhiTrackerService', function(JhiTrackerService) {
                JhiTrackerService.subscribe();
            }],
            onExit: ['JhiTrackerService', function(JhiTrackerService) {
                JhiTrackerService.unsubscribe();
            }]
        });
    }
})();

(function() {
    'use strict';
    /* globals SockJS, Stomp */

    angular
        .module('publicGatewayApp')
        .factory('JhiTrackerService', JhiTrackerService);

    JhiTrackerService.$inject = ['$rootScope', '$window', '$cookies', '$http', '$q', 'AuthServerProvider'];

    function JhiTrackerService ($rootScope, $window, $cookies, $http, $q, AuthServerProvider) {
        var stompClient = null;
        var subscriber = null;
        var listener = $q.defer();
        var connected = $q.defer();
        var alreadyConnectedOnce = false;

        var service = {
            connect: connect,
            disconnect: disconnect,
            receive: receive,
            sendActivity: sendActivity,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };

        return service;

        function connect () {
            //building absolute path so that websocket doesn't fail when deploying with a context path
            var loc = $window.location;
            var url = '//' + loc.host + loc.pathname + 'websocket/tracker';
            var authToken = AuthServerProvider.getToken();
            if(authToken){
                url += '?access_token=' + authToken;
            }
            var socket = new SockJS(url);
            stompClient = Stomp.over(socket);
            var stateChangeStart;
            var headers = {};
            stompClient.connect(headers, function() {
                connected.resolve('success');
                sendActivity();
                if (!alreadyConnectedOnce) {
                    stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
                        sendActivity();
                    });
                    alreadyConnectedOnce = true;
                }
            });
            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
            });
        }

        function disconnect () {
            if (stompClient !== null) {
                stompClient.disconnect();
                stompClient = null;
            }
        }

        function receive () {
            return listener.promise;
        }

        function sendActivity() {
            if (stompClient !== null && stompClient.connected) {
                stompClient
                    .send('/topic/activity',
                    {},
                    angular.toJson({'page': $rootScope.toState.name}));
            }
        }

        function subscribe () {
            connected.promise.then(function() {
                subscriber = stompClient.subscribe('/topic/tracker', function(data) {
                    listener.notify(angular.fromJson(data.body));
                });
            }, null, null);
        }

        function unsubscribe () {
            if (subscriber !== null) {
                subscriber.unsubscribe();
            }
            listener = $q.defer();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('JhiTrackerController', JhiTrackerController);

    JhiTrackerController.$inject = ['$cookies', '$http', 'JhiTrackerService'];

    function JhiTrackerController ($cookies, $http, JhiTrackerService) {
        // This controller uses a Websocket connection to receive user activities in real-time.
        var vm = this;

        vm.activities = [];

        JhiTrackerService.receive().then(null, null, function(activity) {
            showActivity(activity);
        });

        function showActivity(activity) {
            var existingActivity = false;
            for (var index = 0; index < vm.activities.length; index++) {
                if(vm.activities[index].sessionId === activity.sessionId) {
                    existingActivity = true;
                    if (activity.page === 'logout') {
                        vm.activities.splice(index, 1);
                    } else {
                        vm.activities[index] = activity;
                    }
                }
            }
            if (!existingActivity && (activity.page !== 'logout')) {
                vm.activities.push(activity);
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.includes('web.rest') || key.includes('service')) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('publicGatewayApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('GatewayRoutes', GatewayRoutes);

    GatewayRoutes.$inject = ['$resource'];

    function GatewayRoutes ($resource) {
        var service = $resource('api/gateway/routes/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('gateway', {
            parent: 'admin',
            url: '/gateway',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'gateway.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/gateway/gateway.html',
                    controller: 'GatewayController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gateway');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('GatewayRoutes', GatewayRoutes);

    GatewayRoutes.$inject = ['$resource'];

    function GatewayRoutes ($resource) {
        var service = $resource('api/gateway/routes/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('GatewayController', GatewayController);

    GatewayController.$inject = ['$filter', '$interval', 'GatewayRoutes'];

    function GatewayController ($filter, $interval, GatewayRoutes) {
        var vm = this;

        vm.gatewayRoutes = null;
        vm.refresh = refresh;
        vm.updatingRoutes = null;

        vm.refresh();

        function refresh () {
            vm.updatingRoutes = true;
            GatewayRoutes.query(function(result) {
                vm.gatewayRoutes = result;
                vm.updatingRoutes = false;
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('SocialRegisterController', SocialRegisterController);

    SocialRegisterController.$inject = ['$filter', '$stateParams'];

    function SocialRegisterController ($filter, $stateParams) {
        var vm = this;

        vm.success = $stateParams.success;
        vm.error = !vm.success;
        vm.provider = $stateParams.provider;
        vm.providerLabel = $filter('capitalize')(vm.provider);
        vm.success = $stateParams.success;
    }
})();

(function () {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('SocialAuthController', SocialAuthController);

    SocialAuthController.$inject = ['$state', '$cookies', 'Auth'];

    function SocialAuthController($state, $cookies, Auth) {
        var token = $cookies.get('social-authentication');

        Auth.loginWithToken(token, false).then(function () {
            $cookies.remove('social-authentication');
            Auth.authorize(true);
        }, function () {
            $state.go('social-register', {'success': 'false'});
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('social-register', {
            parent: 'account',
            url: '/social-register/:provider?{success:boolean}',
            data: {
                authorities: [],
                pageTitle: 'social.register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/social/social-register.html',
                    controller: 'SocialRegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('social');
                    return $translate.refresh();
                }]
            }
        })
        .state('social-auth', {
            parent: 'account',
            url: '/social-auth',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    controller: 'SocialAuthController'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('SocialService', SocialService);

    SocialService.$inject = ['$http', '$cookies'];

    function SocialService ($http, $cookies) {
        var socialService = {
            getProviderSetting: getProviderSetting,
            getProviderURL: getProviderURL,
            getCSRF: getCSRF
        };

        return socialService;

        function getProviderSetting (provider) {
            switch(provider) {
            case 'google': return 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email';
            case 'facebook': return 'public_profile,email';
            case 'twitter': return '';
                // jhipster-needle-add-social-button
            default: return 'Provider setting not defined';
            }
        }

        function getProviderURL (provider) {
            return 'signin/' + provider;
        }

        function getCSRF () {
            return $cookies.get($http.defaults.xsrfCookieName);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .directive('jhSocial', jhSocial);

    jhSocial.$inject = ['$translatePartialLoader', '$translate', '$filter', 'SocialService'];

    function jhSocial($translatePartialLoader, $translate, $filter, SocialService) {
        var directive = {
            restrict: 'E',
            scope: {
                provider: '@ngProvider'
            },
            templateUrl: 'app/account/social/directive/social.html',
            link: linkFunc
        };

        return directive;

        /* private helper methods */

        function linkFunc(scope) {
            
            $translatePartialLoader.addPart('social');
            $translate.refresh();
            
            scope.label = $filter('capitalize')(scope.provider);
            scope.providerSetting = SocialService.getProviderSetting(scope.provider);
            scope.providerURL = SocialService.getProviderURL(scope.provider);
            scope.csrf = SocialService.getCSRF();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth', 'errorConstants'];

    function RequestResetController ($timeout, Auth, errorConstants) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_NOT_FOUND_TYPE) {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService', 'errorConstants'];

    function RegisterController ($translate, $timeout, Auth, LoginService, errorConstants) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.LOGIN_ALREADY_USED_TYPE) {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_ALREADY_USED_TYPE) {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('publicGatewayApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="home.title">Welcome, Java Hipster!</h1><p class="lead" data-translate="home.subtitle">This is your homepage</p><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true" data-translate="home.logged.message" translate-values="{username: \'{{vm.account.login}}\'}">You are logged in as user "{{vm.account.login}}".</div><div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div><div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" ui-sref="register">Register a new account</a></div></div><p data-translate="home.question">If you have any question on JHipster:</p><ul><li><a href="http://www.jhipster.tech/" target="_blank" rel="noopener" data-translate="home.link.homepage">JHipster homepage</a></li><li><a href="http://stackoverflow.com/tags/jhipster/info" target="_blank" rel="noopener" data-translate="home.link.stackoverflow">JHipster on Stack Overflow</a></li><li><a href="https://github.com/jhipster/generator-jhipster/issues?state=open" target="_blank" rel="noopener" data-translate="home.link.bugtracker">JHipster bug tracker</a></li><li><a href="https://gitter.im/jhipster/generator-jhipster" target="_blank" rel="noopener" data-translate="home.link.chat">JHipster public chat room</a></li><li><a href="https://twitter.com/java_hipster" target="_blank" rel="noopener" data-translate="home.link.follow">follow @java_hipster on Twitter</a></li></ul><p><span data-translate="home.like">If you like JHipster, don\'t forget to give us a star on </span>&nbsp;<a href="https://github.com/jhipster/generator-jhipster" target="_blank" rel="noopener" data-translate="home.github">GitHub</a>!</p></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>Email is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-4 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div><div class="col-md-4"><br><jh-social ng-provider="google"></jh-social><jh-social ng-provider="facebook"></jh-social><jh-social ng-provider="twitter"></jh-social><!-- jhipster-needle-add-social-button --></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/social/social-register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 ng-show="success" data-translate="social.register.title" translate-values="{ label: vm.providerLabel }">Registration with</h1><h1 ng-show="error" data-translate="social.register.errorTitle">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="social.register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="social.register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><jh-social ng-if="vm.success" ng-provider="{{ vm.provider }}"></jh-social><br><div class="alert alert-warning" data-translate="global.messages.info.authenticated">If you want to <a class="alert-link" href="#/login">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><h3 ng-hide="filteredConfig.length === 0">Spring configuration</h3><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length === 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-success break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><h4 ng-hide="filtered.length === 0"><span>{{key}}</span></h4><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length === 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-success break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/gateway/gateway.html','<div><h2 data-translate="gateway.title">Gateway</h2><h3 data-translate="gateway.routes.title">Current routes</h3><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()" ng-show="vm.updatingRoutes === false"><span class="glyphicon glyphicon-refresh glyphicon-"></span>&nbsp;<span data-translate="gateway.refresh.button">Refresh</span></button> <button type="button" class="btn btn-danger" ng-show="vm.updatingRoutes"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="gateway.refresh.button">Refresh</span></button></p><table class="table table-striped table-responsive"><thead><tr><th data-translate="gateway.routes.url">URL</th><th data-translate="gateway.routes.service">Service</th><th data-translate="gateway.routes.servers">Available servers</th></tr></thead><tr ng-repeat="route in vm.gatewayRoutes"><td>{{route.path}}</td><td>{{route.serviceId}}</td><td><div ng-show="{{route.serviceInstances.length === 0}}" class="label label-danger" data-translate="gateway.routes.error">Warning: no server available!</div><table class="table table-responsive"><tr ng-repeat="instance in route.serviceInstances"><td>{{instance.host}}:{{instance.port}}</td><td ng-show="{{instance.instanceInfo.status === \'UP\'}}"><div class="label label-success">{{instance.instanceInfo.status}}</div></td><td ng-hide="{{instance.instanceInfo.status === \'UP\'}}"><div class="label label-danger">{{instance.instanceInfo.status}}</div></td></tr></table></td></tr></table></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/tracker/tracker.html','<div><h2 data-translate="tracker.title">Real-time user activities</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="tracker.table.userlogin">User</th><th data-translate="tracker.table.ipaddress">IP Address</th><th data-translate="tracker.table.page">Current page</th><th data-translate="tracker.table.time">Time</th><th></th></tr></thead><tbody><tr ng-repeat="activity in vm.activities"><td>{{activity.userLogin}}</td><td>{{activity.ipAddress}}</td><td>{{activity.page}}</td><td>{{activity.time | date:\'yyyy-MM-dd HH:mm:ss\'}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.user.id"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" required ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login === user.login" data-translate="userManagement.activated">Activated</button></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login === user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-6"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div><div class="alert alert-warning" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a></div></div><div class="col-md-6"><br><jh-social ng-provider="google"></jh-social><jh-social ng-provider="facebook"></jh-social><jh-social ng-provider="twitter"></jh-social><!-- jhipster-needle-add-social-button --></div></div></div>');
$templateCache.put('app/entities/city/cities.html','<div><h2 data-translate="publicGatewayApp.city.home.title">Cities</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="city.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="publicGatewayApp.city.home.createLabel">Create new City</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'publicGatewayApp.city.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="geonameId"><span data-translate="publicGatewayApp.city.geonameId">Geoname Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="publicGatewayApp.city.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="asciiName"><span data-translate="publicGatewayApp.city.asciiName">Ascii Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="alternateNames"><span data-translate="publicGatewayApp.city.alternateNames">Alternate Names</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="latitude"><span data-translate="publicGatewayApp.city.latitude">Latitude</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="longitude"><span data-translate="publicGatewayApp.city.longitude">Longitude</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="featureClass"><span data-translate="publicGatewayApp.city.featureClass">Feature Class</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="featureCode"><span data-translate="publicGatewayApp.city.featureCode">Feature Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="countryCode"><span data-translate="publicGatewayApp.city.countryCode">Country Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cc2"><span data-translate="publicGatewayApp.city.cc2">Cc 2</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="admin1Code"><span data-translate="publicGatewayApp.city.admin1Code">Admin 1 Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="admin2Code"><span data-translate="publicGatewayApp.city.admin2Code">Admin 2 Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="admin3Code"><span data-translate="publicGatewayApp.city.admin3Code">Admin 3 Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="admin4Code"><span data-translate="publicGatewayApp.city.admin4Code">Admin 4 Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="population"><span data-translate="publicGatewayApp.city.population">Population</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="elevation"><span data-translate="publicGatewayApp.city.elevation">Elevation</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dem"><span data-translate="publicGatewayApp.city.dem">Dem</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="timezone"><span data-translate="publicGatewayApp.city.timezone">Timezone</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="modificationDate"><span data-translate="publicGatewayApp.city.modificationDate">Modification Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="city in vm.cities track by city.id"><td><a ui-sref="city-detail({id:city.id})">{{city.id}}</a></td><td>{{city.geonameId}}</td><td>{{city.name}}</td><td>{{city.asciiName}}</td><td>{{city.alternateNames}}</td><td>{{city.latitude}}</td><td>{{city.longitude}}</td><td>{{city.featureClass}}</td><td>{{city.featureCode}}</td><td>{{city.countryCode}}</td><td>{{city.cc2}}</td><td>{{city.admin1Code}}</td><td>{{city.admin2Code}}</td><td>{{city.admin3Code}}</td><td>{{city.admin4Code}}</td><td>{{city.population}}</td><td>{{city.elevation}}</td><td>{{city.dem}}</td><td>{{city.timezone}}</td><td>{{city.modificationDate | date:\'mediumDate\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="city-detail({id:city.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="city.edit({id:city.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="city.delete({id:city.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/city/city-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.city.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="publicGatewayApp.city.delete.question" translate-values="{id: \'{{vm.city.id}}\'}">Are you sure you want to delete this City?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/city/city-detail.html','<div><h2><span data-translate="publicGatewayApp.city.detail.title">City</span> {{vm.city.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="publicGatewayApp.city.geonameId">Geoname Id</span></dt><dd><span>{{vm.city.geonameId}}</span></dd><dt><span data-translate="publicGatewayApp.city.name">Name</span></dt><dd><span>{{vm.city.name}}</span></dd><dt><span data-translate="publicGatewayApp.city.asciiName">Ascii Name</span></dt><dd><span>{{vm.city.asciiName}}</span></dd><dt><span data-translate="publicGatewayApp.city.alternateNames">Alternate Names</span></dt><dd><span>{{vm.city.alternateNames}}</span></dd><dt><span data-translate="publicGatewayApp.city.latitude">Latitude</span></dt><dd><span>{{vm.city.latitude}}</span></dd><dt><span data-translate="publicGatewayApp.city.longitude">Longitude</span></dt><dd><span>{{vm.city.longitude}}</span></dd><dt><span data-translate="publicGatewayApp.city.featureClass">Feature Class</span></dt><dd><span>{{vm.city.featureClass}}</span></dd><dt><span data-translate="publicGatewayApp.city.featureCode">Feature Code</span></dt><dd><span>{{vm.city.featureCode}}</span></dd><dt><span data-translate="publicGatewayApp.city.countryCode">Country Code</span></dt><dd><span>{{vm.city.countryCode}}</span></dd><dt><span data-translate="publicGatewayApp.city.cc2">Cc 2</span></dt><dd><span>{{vm.city.cc2}}</span></dd><dt><span data-translate="publicGatewayApp.city.admin1Code">Admin 1 Code</span></dt><dd><span>{{vm.city.admin1Code}}</span></dd><dt><span data-translate="publicGatewayApp.city.admin2Code">Admin 2 Code</span></dt><dd><span>{{vm.city.admin2Code}}</span></dd><dt><span data-translate="publicGatewayApp.city.admin3Code">Admin 3 Code</span></dt><dd><span>{{vm.city.admin3Code}}</span></dd><dt><span data-translate="publicGatewayApp.city.admin4Code">Admin 4 Code</span></dt><dd><span>{{vm.city.admin4Code}}</span></dd><dt><span data-translate="publicGatewayApp.city.population">Population</span></dt><dd><span>{{vm.city.population}}</span></dd><dt><span data-translate="publicGatewayApp.city.elevation">Elevation</span></dt><dd><span>{{vm.city.elevation}}</span></dd><dt><span data-translate="publicGatewayApp.city.dem">Dem</span></dt><dd><span>{{vm.city.dem}}</span></dd><dt><span data-translate="publicGatewayApp.city.timezone">Timezone</span></dt><dd><span>{{vm.city.timezone}}</span></dd><dt><span data-translate="publicGatewayApp.city.modificationDate">Modification Date</span></dt><dd><span>{{vm.city.modificationDate | date:\'mediumDate\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="city-detail.edit({id:vm.city.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/city/city-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCityLabel" data-translate="publicGatewayApp.city.home.createOrEditLabel">Create or edit a City</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.city.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.city.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.city.geonameId" for="field_geonameId">Geoname Id</label><input type="number" class="form-control" name="geonameId" id="field_geonameId" ng-model="vm.city.geonameId" required><div ng-show="editForm.geonameId.$invalid"><p class="help-block" ng-show="editForm.geonameId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.geonameId.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.city.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.city.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.city.asciiName" for="field_asciiName">Ascii Name</label><input type="text" class="form-control" name="asciiName" id="field_asciiName" ng-model="vm.city.asciiName" required><div ng-show="editForm.asciiName.$invalid"><p class="help-block" ng-show="editForm.asciiName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.city.alternateNames" for="field_alternateNames">Alternate Names</label><input type="text" class="form-control" name="alternateNames" id="field_alternateNames" ng-model="vm.city.alternateNames" ng-maxlength="10000"><div ng-show="editForm.alternateNames.$invalid"><p class="help-block" ng-show="editForm.alternateNames.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10000">This field cannot be longer than 10000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.city.latitude" for="field_latitude">Latitude</label><input type="number" class="form-control" name="latitude" id="field_latitude" ng-model="vm.city.latitude"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.city.longitude" for="field_longitude">Longitude</label><input type="number" class="form-control" name="longitude" id="field_longitude" ng-model="vm.city.longitude"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.city.featureClass" for="field_featureClass">Feature Class</label><input type="text" class="form-control" name="featureClass" id="field_featureClass" ng-model="vm.city.featureClass"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.city.featureCode" for="field_featureCode">Feature Code</label><input type="text" class="form-control" name="featureCode" id="field_featureCode" ng-model="vm.city.featureCode"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.city.countryCode" for="field_countryCode">Country Code</label><input type="text" class="form-control" name="countryCode" id="field_countryCode" ng-model="vm.city.countryCode"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.city.cc2" for="field_cc2">Cc 2</label><input type="text" class="form-control" name="cc2" id="field_cc2" ng-model="vm.city.cc2"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.city.admin1Code" for="field_admin1Code">Admin 1 Code</label><input type="text" class="form-control" name="admin1Code" id="field_admin1Code" ng-model="vm.city.admin1Code"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.city.admin2Code" for="field_admin2Code">Admin 2 Code</label><input type="text" class="form-control" name="admin2Code" id="field_admin2Code" ng-model="vm.city.admin2Code"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.city.admin3Code" for="field_admin3Code">Admin 3 Code</label><input type="text" class="form-control" name="admin3Code" id="field_admin3Code" ng-model="vm.city.admin3Code"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.city.admin4Code" for="field_admin4Code">Admin 4 Code</label><input type="text" class="form-control" name="admin4Code" id="field_admin4Code" ng-model="vm.city.admin4Code"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.city.population" for="field_population">Population</label><input type="number" class="form-control" name="population" id="field_population" ng-model="vm.city.population"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.city.elevation" for="field_elevation">Elevation</label><input type="number" class="form-control" name="elevation" id="field_elevation" ng-model="vm.city.elevation"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.city.dem" for="field_dem">Dem</label><input type="number" class="form-control" name="dem" id="field_dem" ng-model="vm.city.dem"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.city.timezone" for="field_timezone">Timezone</label><input type="text" class="form-control" name="timezone" id="field_timezone" ng-model="vm.city.timezone"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.city.modificationDate" for="field_modificationDate">Modification Date</label><div class="input-group"><input id="field_modificationDate" type="text" class="form-control" name="modificationDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.city.modificationDate" is-open="vm.datePickerOpenStatus.modificationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'modificationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/country/countries.html','<div><h2 data-translate="publicGatewayApp.country.home.title">Countries</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="country.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="publicGatewayApp.country.home.createLabel">Create new Country</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'publicGatewayApp.country.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="geonameId"><span data-translate="publicGatewayApp.country.geonameId">Geoname Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localeCode"><span data-translate="publicGatewayApp.country.localeCode">Locale Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="continentCode"><span data-translate="publicGatewayApp.country.continentCode">Continent Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="continentName"><span data-translate="publicGatewayApp.country.continentName">Continent Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="countryIsoCode"><span data-translate="publicGatewayApp.country.countryIsoCode">Country Iso Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="countryName"><span data-translate="publicGatewayApp.country.countryName">Country Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="country in vm.countries track by country.id"><td><a ui-sref="country-detail({id:country.id})">{{country.id}}</a></td><td>{{country.geonameId}}</td><td>{{country.localeCode}}</td><td>{{country.continentCode}}</td><td>{{country.continentName}}</td><td>{{country.countryIsoCode}}</td><td>{{country.countryName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="country-detail({id:country.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="country.edit({id:country.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="country.delete({id:country.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/country/country-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.country.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="publicGatewayApp.country.delete.question" translate-values="{id: \'{{vm.country.id}}\'}">Are you sure you want to delete this Country?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/country/country-detail.html','<div><h2><span data-translate="publicGatewayApp.country.detail.title">Country</span> {{vm.country.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="publicGatewayApp.country.geonameId">Geoname Id</span></dt><dd><span>{{vm.country.geonameId}}</span></dd><dt><span data-translate="publicGatewayApp.country.localeCode">Locale Code</span></dt><dd><span>{{vm.country.localeCode}}</span></dd><dt><span data-translate="publicGatewayApp.country.continentCode">Continent Code</span></dt><dd><span>{{vm.country.continentCode}}</span></dd><dt><span data-translate="publicGatewayApp.country.continentName">Continent Name</span></dt><dd><span>{{vm.country.continentName}}</span></dd><dt><span data-translate="publicGatewayApp.country.countryIsoCode">Country Iso Code</span></dt><dd><span>{{vm.country.countryIsoCode}}</span></dd><dt><span data-translate="publicGatewayApp.country.countryName">Country Name</span></dt><dd><span>{{vm.country.countryName}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="country-detail.edit({id:vm.country.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/country/country-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCountryLabel" data-translate="publicGatewayApp.country.home.createOrEditLabel">Create or edit a Country</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.country.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.country.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.country.geonameId" for="field_geonameId">Geoname Id</label><input type="number" class="form-control" name="geonameId" id="field_geonameId" ng-model="vm.country.geonameId"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.country.localeCode" for="field_localeCode">Locale Code</label><input type="text" class="form-control" name="localeCode" id="field_localeCode" ng-model="vm.country.localeCode"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.country.continentCode" for="field_continentCode">Continent Code</label><input type="text" class="form-control" name="continentCode" id="field_continentCode" ng-model="vm.country.continentCode"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.country.continentName" for="field_continentName">Continent Name</label><input type="text" class="form-control" name="continentName" id="field_continentName" ng-model="vm.country.continentName"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.country.countryIsoCode" for="field_countryIsoCode">Country Iso Code</label><input type="text" class="form-control" name="countryIsoCode" id="field_countryIsoCode" ng-model="vm.country.countryIsoCode"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.country.countryName" for="field_countryName">Country Name</label><input type="text" class="form-control" name="countryName" id="field_countryName" ng-model="vm.country.countryName"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/gender/gender-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.gender.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="publicGatewayApp.gender.delete.question" translate-values="{id: \'{{vm.gender.id}}\'}">Are you sure you want to delete this Gender?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/gender/gender-detail.html','<div><h2><span data-translate="publicGatewayApp.gender.detail.title">Gender</span> {{vm.gender.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="publicGatewayApp.gender.name">Name</span></dt><dd><span>{{vm.gender.name}}</span></dd><dt><span data-translate="publicGatewayApp.gender.shortName">Short Name</span></dt><dd><span>{{vm.gender.shortName}}</span></dd><dt><span data-translate="publicGatewayApp.gender.title">Title</span></dt><dd><span>{{vm.gender.title}}</span></dd><dt><span data-translate="publicGatewayApp.gender.sortOrder">Sort Order</span></dt><dd><span>{{vm.gender.sortOrder}}</span></dd><dt><span data-translate="publicGatewayApp.gender.enable">Enable</span></dt><dd><span>{{vm.gender.enable}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="gender-detail.edit({id:vm.gender.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/gender/gender-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGenderLabel" data-translate="publicGatewayApp.gender.home.createOrEditLabel">Create or edit a Gender</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.gender.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.gender.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.gender.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.gender.name" required ng-minlength="1" ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.gender.shortName" for="field_shortName">Short Name</label><input type="text" class="form-control" name="shortName" id="field_shortName" ng-model="vm.gender.shortName" required ng-minlength="1" ng-maxlength="32"><div ng-show="editForm.shortName.$invalid"><p class="help-block" ng-show="editForm.shortName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.shortName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.shortName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.gender.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.gender.title" required ng-minlength="1" ng-maxlength="32"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.title.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.title.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.gender.sortOrder" for="field_sortOrder">Sort Order</label><input type="number" class="form-control" name="sortOrder" id="field_sortOrder" ng-model="vm.gender.sortOrder"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.gender.enable" for="field_enable">Enable</label><input type="checkbox" class="form-control" name="enable" id="field_enable" ng-model="vm.gender.enable"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/gender/genders.html','<div><h2 data-translate="publicGatewayApp.gender.home.title">Genders</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="gender.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="publicGatewayApp.gender.home.createLabel">Create new Gender</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'publicGatewayApp.gender.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="publicGatewayApp.gender.name">Name</span></th><th><span data-translate="publicGatewayApp.gender.shortName">Short Name</span></th><th><span data-translate="publicGatewayApp.gender.title">Title</span></th><th><span data-translate="publicGatewayApp.gender.sortOrder">Sort Order</span></th><th><span data-translate="publicGatewayApp.gender.enable">Enable</span></th><th></th></tr></thead><tbody><tr ng-repeat="gender in vm.genders track by gender.id"><td><a ui-sref="gender-detail({id:gender.id})">{{gender.id}}</a></td><td>{{gender.name}}</td><td>{{gender.shortName}}</td><td>{{gender.title}}</td><td>{{gender.sortOrder}}</td><td>{{gender.enable}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="gender-detail({id:gender.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="gender.edit({id:gender.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="gender.delete({id:gender.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/geoname-localization/geoname-localization-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.geonameLocalization.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="publicGatewayApp.geonameLocalization.delete.question" translate-values="{id: \'{{vm.geonameLocalization.id}}\'}">Are you sure you want to delete this Geoname Localization?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/geoname-localization/geoname-localization-detail.html','<div><h2><span data-translate="publicGatewayApp.geonameLocalization.detail.title">Geoname Localization</span> {{vm.geonameLocalization.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="publicGatewayApp.geonameLocalization.geonameId">Geoname Id</span></dt><dd><span>{{vm.geonameLocalization.geonameId}}</span></dd><dt><span data-translate="publicGatewayApp.geonameLocalization.language">Language</span></dt><dd><span>{{vm.geonameLocalization.language}}</span></dd><dt><span data-translate="publicGatewayApp.geonameLocalization.name">Name</span></dt><dd><span>{{vm.geonameLocalization.name}}</span></dd><dt><span data-translate="publicGatewayApp.geonameLocalization.isPreferredName">Is Preferred Name</span></dt><dd><span>{{vm.geonameLocalization.isPreferredName}}</span></dd><dt><span data-translate="publicGatewayApp.geonameLocalization.isShortName">Is Short Name</span></dt><dd><span>{{vm.geonameLocalization.isShortName}}</span></dd><dt><span data-translate="publicGatewayApp.geonameLocalization.isColloquial">Is Colloquial</span></dt><dd><span>{{vm.geonameLocalization.isColloquial}}</span></dd><dt><span data-translate="publicGatewayApp.geonameLocalization.isHistoric">Is Historic</span></dt><dd><span>{{vm.geonameLocalization.isHistoric}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="geoname-localization-detail.edit({id:vm.geonameLocalization.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/geoname-localization/geoname-localization-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGeonameLocalizationLabel" data-translate="publicGatewayApp.geonameLocalization.home.createOrEditLabel">Create or edit a Geoname Localization</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.geonameLocalization.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.geonameLocalization.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.geonameLocalization.geonameId" for="field_geonameId">Geoname Id</label><input type="number" class="form-control" name="geonameId" id="field_geonameId" ng-model="vm.geonameLocalization.geonameId" required><div ng-show="editForm.geonameId.$invalid"><p class="help-block" ng-show="editForm.geonameId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.geonameId.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.geonameLocalization.language" for="field_language">Language</label><input type="text" class="form-control" name="language" id="field_language" ng-model="vm.geonameLocalization.language" required ng-maxlength="2"><div ng-show="editForm.language.$invalid"><p class="help-block" ng-show="editForm.language.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.language.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2">This field cannot be longer than 2 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.geonameLocalization.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.geonameLocalization.name" required ng-maxlength="255"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.geonameLocalization.isPreferredName" for="field_isPreferredName">Is Preferred Name</label><input type="checkbox" name="isPreferredName" id="field_isPreferredName" ng-model="vm.geonameLocalization.isPreferredName"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.geonameLocalization.isShortName" for="field_isShortName">Is Short Name</label><input type="checkbox" name="isShortName" id="field_isShortName" ng-model="vm.geonameLocalization.isShortName"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.geonameLocalization.isColloquial" for="field_isColloquial">Is Colloquial</label><input type="checkbox" name="isColloquial" id="field_isColloquial" ng-model="vm.geonameLocalization.isColloquial"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.geonameLocalization.isHistoric" for="field_isHistoric">Is Historic</label><input type="checkbox" name="isHistoric" id="field_isHistoric" ng-model="vm.geonameLocalization.isHistoric"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/geoname-localization/geoname-localizations.html','<div><h2 data-translate="publicGatewayApp.geonameLocalization.home.title">Geoname Localizations</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="geoname-localization.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="publicGatewayApp.geonameLocalization.home.createLabel">Create new Geoname Localization</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'publicGatewayApp.geonameLocalization.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="geonameId"><span data-translate="publicGatewayApp.geonameLocalization.geonameId">Geoname Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="language"><span data-translate="publicGatewayApp.geonameLocalization.language">Language</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="publicGatewayApp.geonameLocalization.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isPreferredName"><span data-translate="publicGatewayApp.geonameLocalization.isPreferredName">Is Preferred Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isShortName"><span data-translate="publicGatewayApp.geonameLocalization.isShortName">Is Short Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isColloquial"><span data-translate="publicGatewayApp.geonameLocalization.isColloquial">Is Colloquial</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isHistoric"><span data-translate="publicGatewayApp.geonameLocalization.isHistoric">Is Historic</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="geonameLocalization in vm.geonameLocalizations track by geonameLocalization.id"><td><a ui-sref="geoname-localization-detail({id:geonameLocalization.id})">{{geonameLocalization.id}}</a></td><td>{{geonameLocalization.geonameId}}</td><td>{{geonameLocalization.language}}</td><td>{{geonameLocalization.name}}</td><td>{{geonameLocalization.isPreferredName}}</td><td>{{geonameLocalization.isShortName}}</td><td>{{geonameLocalization.isColloquial}}</td><td>{{geonameLocalization.isHistoric}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="geoname-localization-detail({id:geonameLocalization.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="geoname-localization.edit({id:geonameLocalization.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="geoname-localization.delete({id:geonameLocalization.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/language/language-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.language.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="publicGatewayApp.language.delete.question" translate-values="{id: \'{{vm.language.id}}\'}">Are you sure you want to delete this Language?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/language/language-detail.html','<div><h2><span data-translate="publicGatewayApp.language.detail.title">Language</span> {{vm.language.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="publicGatewayApp.language.name">Name</span></dt><dd><span>{{vm.language.name}}</span></dd><dt><span data-translate="publicGatewayApp.language.shortName">Short Name</span></dt><dd><span>{{vm.language.shortName}}</span></dd><dt><span data-translate="publicGatewayApp.language.sortOrder">Sort Order</span></dt><dd><span>{{vm.language.sortOrder}}</span></dd><dt><span data-translate="publicGatewayApp.language.enable">Enable</span></dt><dd><span>{{vm.language.enable}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="language-detail.edit({id:vm.language.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/language/language-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLanguageLabel" data-translate="publicGatewayApp.language.home.createOrEditLabel">Create or edit a Language</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.language.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.language.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.language.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.language.name" required ng-minlength="1" ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.language.shortName" for="field_shortName">Short Name</label><input type="text" class="form-control" name="shortName" id="field_shortName" ng-model="vm.language.shortName" required ng-minlength="1" ng-maxlength="32"><div ng-show="editForm.shortName.$invalid"><p class="help-block" ng-show="editForm.shortName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.shortName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.shortName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.language.sortOrder" for="field_sortOrder">Sort Order</label><input type="number" class="form-control" name="sortOrder" id="field_sortOrder" ng-model="vm.language.sortOrder"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.language.enable" for="field_enable">Enable</label><input type="checkbox" class="form-control" name="enable" id="field_enable" ng-model="vm.language.enable"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/language/languages.html','<div><h2 data-translate="publicGatewayApp.language.home.title">Languages</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="language.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="publicGatewayApp.language.home.createLabel">Create new Language</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'publicGatewayApp.language.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="publicGatewayApp.language.name">Name</span></th><th><span data-translate="publicGatewayApp.language.shortName">Short Name</span></th><th><span data-translate="publicGatewayApp.language.sortOrder">Sort Order</span></th><th><span data-translate="publicGatewayApp.language.enable">Enable</span></th><th></th></tr></thead><tbody><tr ng-repeat="language in vm.languages track by language.id"><td><a ui-sref="language-detail({id:language.id})">{{language.id}}</a></td><td>{{language.name}}</td><td>{{language.shortName}}</td><td>{{language.sortOrder}}</td><td>{{language.enable}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="language-detail({id:language.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="language.edit({id:language.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="language.delete({id:language.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/location/location-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.location.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="publicGatewayApp.location.delete.question" translate-values="{id: \'{{vm.location.id}}\'}">Are you sure you want to delete this Location?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/location/location-detail.html','<div><h2><span data-translate="publicGatewayApp.location.detail.title">Location</span> {{vm.location.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="publicGatewayApp.location.cityName">City Name</span></dt><dd><span>{{vm.location.cityName}}</span></dd><dt><span data-translate="publicGatewayApp.location.internalName">Internal Name</span></dt><dd><span>{{vm.location.internalName}}</span></dd><dt><span data-translate="publicGatewayApp.location.country">Country</span></dt><dd><a ui-sref="country-detail({id:vm.location.country.id})">{{vm.location.country.id}}</a></dd><dt><span data-translate="publicGatewayApp.location.region">Region</span></dt><dd><a ui-sref="region-detail({id:vm.location.region.id})">{{vm.location.region.id}}</a></dd><dt><span data-translate="publicGatewayApp.location.city">City</span></dt><dd><a ui-sref="city-detail({id:vm.location.city.id})">{{vm.location.city.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="location-detail.edit({id:vm.location.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/location/location-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLocationLabel" data-translate="publicGatewayApp.location.home.createOrEditLabel">Create or edit a Location</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.location.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.location.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.location.cityName" for="field_cityName">City Name</label><input type="text" class="form-control" name="cityName" id="field_cityName" ng-model="vm.location.cityName"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.location.internalName" for="field_internalName">Internal Name</label><input type="text" class="form-control" name="internalName" id="field_internalName" ng-model="vm.location.internalName"></div><div class="form-group"><label data-translate="publicGatewayApp.location.country" for="field_country">Country</label><select class="form-control" id="field_country" name="country" ng-model="vm.location.country" ng-options="country as country.id for country in vm.countries track by country.id"><option value=""></option></select></div><div class="form-group"><label data-translate="publicGatewayApp.location.region" for="field_region">Region</label><select class="form-control" id="field_region" name="region" ng-model="vm.location.region" ng-options="region as region.id for region in vm.regions track by region.id"><option value=""></option></select></div><div class="form-group"><label data-translate="publicGatewayApp.location.city" for="field_city">City</label><select class="form-control" id="field_city" name="city" ng-model="vm.location.city" ng-options="city as city.id for city in vm.cities track by city.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/location/locations.html','<div><h2 data-translate="publicGatewayApp.location.home.title">Locations</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="location.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="publicGatewayApp.location.home.createLabel">Create new Location</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'publicGatewayApp.location.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cityName"><span data-translate="publicGatewayApp.location.cityName">City Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="internalName"><span data-translate="publicGatewayApp.location.internalName">Internal Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="country.id"><span data-translate="publicGatewayApp.location.country">Country</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="region.id"><span data-translate="publicGatewayApp.location.region">Region</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="city.id"><span data-translate="publicGatewayApp.location.city">City</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="location in vm.locations track by location.id"><td><a ui-sref="location-detail({id:location.id})">{{location.id}}</a></td><td>{{location.cityName}}</td><td>{{location.internalName}}</td><td><a ui-sref="country-detail({id:location.country.id})">{{location.country.id}}</a></td><td><a ui-sref="region-detail({id:location.region.id})">{{location.region.id}}</a></td><td><a ui-sref="city-detail({id:location.city.id})">{{location.city.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="location-detail({id:location.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="location.edit({id:location.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="location.delete({id:location.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/own-profile/own-profile-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ownProfile.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="publicGatewayApp.ownProfile.delete.question" translate-values="{id: \'{{vm.ownProfile.id}}\'}">Are you sure you want to delete this Own Profile?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/own-profile/own-profile-detail.html','<div><h2><span translate="publicGatewayApp.ownProfile.detail.title">Own Profile</span> {{vm.ownProfile.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="publicGatewayApp.ownProfile.screenName">Screen Name</span></dt><dd><span>{{vm.ownProfile.screenName}}</span></dd><dt><span translate="publicGatewayApp.ownProfile.age">Age</span></dt><dd><span>{{vm.ownProfile.age}}</span></dd><dt><span translate="publicGatewayApp.ownProfile.dob">Dob</span></dt><dd><span>{{vm.ownProfile.dob | date:\'mediumDate\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="own-profile-detail.edit({id:vm.ownProfile.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/own-profile/own-profile-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOwnProfileLabel" translate="publicGatewayApp.ownProfile.home.createOrEditLabel">Create or edit a Own Profile</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.ownProfile.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ownProfile.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="publicGatewayApp.ownProfile.screenName" for="field_screenName">Screen Name</label><input type="text" class="form-control" name="screenName" id="field_screenName" ng-model="vm.ownProfile.screenName" required ng-minlength="1" ng-maxlength="20" ng-pattern="/^[a-zA-Z0-9]*$/"><div ng-show="editForm.screenName.$invalid"><p class="help-block" ng-show="editForm.screenName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.screenName.$error.minlength" translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.screenName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p><p class="help-block" ng-show="editForm.screenName.$error.pattern" translate="entity.validation.pattern" translate-value-pattern="^[a-zA-Z0-9]*$">This field should follow pattern "^[a-zA-Z0-9]*$".</p></div></div><div class="form-group"><label class="control-label" translate="publicGatewayApp.ownProfile.age" for="field_age">Age</label><input type="number" class="form-control" name="age" id="field_age" ng-model="vm.ownProfile.age" required min="18" max="100"><div ng-show="editForm.age.$invalid"><p class="help-block" ng-show="editForm.age.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.age.$error.min" translate="entity.validation.min" translate-value-min="18">This field should be more than 18.</p><p class="help-block" ng-show="editForm.age.$error.max" translate="entity.validation.max" translate-value-max="100">This field cannot be more than 100.</p><p class="help-block" ng-show="editForm.age.$error.number" translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" translate="publicGatewayApp.ownProfile.dob" for="field_dob">Dob</label><div class="input-group"><input id="field_dob" type="text" class="form-control" name="dob" uib-datepicker-popup="{{dateformat}}" ng-model="vm.ownProfile.dob" is-open="vm.datePickerOpenStatus.dob"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dob\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/own-profile/own-profiles.html','<div><h2 translate="publicGatewayApp.ownProfile.home.title">Own Profiles</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="own-profile.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="publicGatewayApp.ownProfile.home.createLabel">Create new Own Profile</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'publicGatewayApp.ownProfile.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="screenName"><span translate="publicGatewayApp.ownProfile.screenName">Screen Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="age"><span translate="publicGatewayApp.ownProfile.age">Age</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dob"><span translate="publicGatewayApp.ownProfile.dob">Dob</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="ownProfile in vm.ownProfiles track by ownProfile.id"><td><a ui-sref="own-profile-detail({id:ownProfile.id})">{{ownProfile.id}}</a></td><td>{{ownProfile.screenName}}</td><td>{{ownProfile.age}}</td><td>{{ownProfile.dob | date:\'mediumDate\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="own-profile-detail({id:ownProfile.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="own-profile.edit({id:ownProfile.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="own-profile.delete({id:ownProfile.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/photo/photo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.photo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="publicGatewayApp.photo.delete.question" translate-values="{id: \'{{vm.photo.id}}\'}">Are you sure you want to delete this Photo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/photo/photo-detail.html','<div><h2><span data-translate="publicGatewayApp.photo.detail.title">Photo</span> {{vm.photo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="publicGatewayApp.photo.originalUri">Original Uri</span></dt><dd><span>{{vm.photo.originalUri}}</span></dd><dt><span data-translate="publicGatewayApp.photo.largeUri">Large Uri</span></dt><dd><span>{{vm.photo.largeUri}}</span></dd><dt><span data-translate="publicGatewayApp.photo.mediumUri">Medium Uri</span></dt><dd><span>{{vm.photo.mediumUri}}</span></dd><dt><span data-translate="publicGatewayApp.photo.smallUri">Small Uri</span></dt><dd><span>{{vm.photo.smallUri}}</span></dd><dt><span data-translate="publicGatewayApp.photo.thumbnailUri">Thumbnail Uri</span></dt><dd><span>{{vm.photo.thumbnailUri}}</span></dd><dt><span data-translate="publicGatewayApp.photo.publicProfile">Public Profile</span></dt><dd><a ui-sref="public-profile-detail({id:vm.photo.publicProfile.id})">{{vm.photo.publicProfile.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="photo-detail.edit({id:vm.photo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/photo/photo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPhotoLabel" data-translate="publicGatewayApp.photo.home.createOrEditLabel">Create or edit a Photo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.photo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.photo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.photo.originalUri" for="field_originalUri">Original Uri</label><input type="text" class="form-control" name="originalUri" id="field_originalUri" ng-model="vm.photo.originalUri"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.photo.largeUri" for="field_largeUri">Large Uri</label><input type="text" class="form-control" name="largeUri" id="field_largeUri" ng-model="vm.photo.largeUri"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.photo.mediumUri" for="field_mediumUri">Medium Uri</label><input type="text" class="form-control" name="mediumUri" id="field_mediumUri" ng-model="vm.photo.mediumUri"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.photo.smallUri" for="field_smallUri">Small Uri</label><input type="text" class="form-control" name="smallUri" id="field_smallUri" ng-model="vm.photo.smallUri"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.photo.thumbnailUri" for="field_thumbnailUri">Thumbnail Uri</label><input type="text" class="form-control" name="thumbnailUri" id="field_thumbnailUri" ng-model="vm.photo.thumbnailUri"></div><div class="form-group"><label data-translate="publicGatewayApp.photo.publicProfile" for="field_publicProfile">Public Profile</label><select class="form-control" id="field_publicProfile" name="publicProfile" ng-model="vm.photo.publicProfile" ng-options="publicProfile as publicProfile.id for publicProfile in vm.publicprofiles track by publicProfile.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/photo/photos.html','<div><h2 data-translate="publicGatewayApp.photo.home.title">Photos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="photo.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="publicGatewayApp.photo.home.createLabel">Create new Photo</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'publicGatewayApp.photo.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="publicGatewayApp.photo.originalUri">Original Uri</span></th><th><span data-translate="publicGatewayApp.photo.largeUri">Large Uri</span></th><th><span data-translate="publicGatewayApp.photo.mediumUri">Medium Uri</span></th><th><span data-translate="publicGatewayApp.photo.smallUri">Small Uri</span></th><th><span data-translate="publicGatewayApp.photo.thumbnailUri">Thumbnail Uri</span></th><th><span data-translate="publicGatewayApp.photo.publicProfile">Public Profile</span></th><th></th></tr></thead><tbody><tr ng-repeat="photo in vm.photos track by photo.id"><td><a ui-sref="photo-detail({id:photo.id})">{{photo.id}}</a></td><td>{{photo.originalUri}}</td><td>{{photo.largeUri}}</td><td>{{photo.mediumUri}}</td><td>{{photo.smallUri}}</td><td>{{photo.thumbnailUri}}</td><td><a ui-sref="public-profile-detail({id:photo.publicProfile.id})">{{photo.publicProfile.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="photo-detail({id:photo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="photo.edit({id:photo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="photo.delete({id:photo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/profile-criterion/profile-criteria.html','<div><h2 data-translate="publicGatewayApp.profileCriterion.home.title">Profile Criteria</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="profile-criterion.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="publicGatewayApp.profileCriterion.home.createLabel">Create new Profile Criterion</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'publicGatewayApp.profileCriterion.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="publicGatewayApp.profileCriterion.name">Name</span></th><th><span data-translate="publicGatewayApp.profileCriterion.shortName">Short Name</span></th><th><span data-translate="publicGatewayApp.profileCriterion.sortOrder">Sort Order</span></th><th><span data-translate="publicGatewayApp.profileCriterion.enable">Enable</span></th><th><span data-translate="publicGatewayApp.profileCriterion.type">Type</span></th><th><span data-translate="publicGatewayApp.profileCriterion.measurementUnitName">Measurement Unit Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="profileCriterion in vm.profileCriteria track by profileCriterion.id"><td><a ui-sref="profile-criterion-detail({id:profileCriterion.id})">{{profileCriterion.id}}</a></td><td>{{profileCriterion.name}}</td><td>{{profileCriterion.shortName}}</td><td>{{profileCriterion.sortOrder}}</td><td>{{profileCriterion.enable}}</td><td data-translate="{{\'publicGatewayApp.ProfileCriterionType.\' + profileCriterion.type}}">{{profileCriterion.type}}</td><td>{{profileCriterion.measurementUnitName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="profile-criterion-detail({id:profileCriterion.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="profile-criterion.edit({id:profileCriterion.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="profile-criterion.delete({id:profileCriterion.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/profile-criterion/profile-criterion-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.profileCriterion.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="publicGatewayApp.profileCriterion.delete.question" translate-values="{id: \'{{vm.profileCriterion.id}}\'}">Are you sure you want to delete this Profile Criterion?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/profile-criterion/profile-criterion-detail.html','<div><h2><span data-translate="publicGatewayApp.profileCriterion.detail.title">Profile Criterion</span> {{vm.profileCriterion.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="publicGatewayApp.profileCriterion.name">Name</span></dt><dd><span>{{vm.profileCriterion.name}}</span></dd><dt><span data-translate="publicGatewayApp.profileCriterion.shortName">Short Name</span></dt><dd><span>{{vm.profileCriterion.shortName}}</span></dd><dt><span data-translate="publicGatewayApp.profileCriterion.sortOrder">Sort Order</span></dt><dd><span>{{vm.profileCriterion.sortOrder}}</span></dd><dt><span data-translate="publicGatewayApp.profileCriterion.enable">Enable</span></dt><dd><span>{{vm.profileCriterion.enable}}</span></dd><dt><span data-translate="publicGatewayApp.profileCriterion.type">Type</span></dt><dd><span data-translate="{{\'publicGatewayApp.ProfileCriterionType.\' + vm.profileCriterion.type}}">{{vm.profileCriterion.type}}</span></dd><dt><span data-translate="publicGatewayApp.profileCriterion.measurementUnitName">Measurement Unit Name</span></dt><dd><span>{{vm.profileCriterion.measurementUnitName}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="profile-criterion-detail.edit({id:vm.profileCriterion.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/profile-criterion/profile-criterion-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProfileCriterionLabel" data-translate="publicGatewayApp.profileCriterion.home.createOrEditLabel">Create or edit a Profile Criterion</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.profileCriterion.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.profileCriterion.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.profileCriterion.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.profileCriterion.name" required ng-minlength="1" ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.profileCriterion.shortName" for="field_shortName">Short Name</label><input type="text" class="form-control" name="shortName" id="field_shortName" ng-model="vm.profileCriterion.shortName" required ng-minlength="1" ng-maxlength="32"><div ng-show="editForm.shortName.$invalid"><p class="help-block" ng-show="editForm.shortName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.shortName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.shortName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.profileCriterion.sortOrder" for="field_sortOrder">Sort Order</label><input type="number" class="form-control" name="sortOrder" id="field_sortOrder" ng-model="vm.profileCriterion.sortOrder"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.profileCriterion.enable" for="field_enable">Enable</label><input type="checkbox" class="form-control" name="enable" id="field_enable" ng-model="vm.profileCriterion.enable"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.profileCriterion.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.profileCriterion.type" id="field_type"><option value="BOOLEAN" data-translate="publicGatewayApp.ProfileCriterionType.BOOLEAN">BOOLEAN</option><option value="STRING" data-translate="publicGatewayApp.ProfileCriterionType.STRING">STRING</option><option value="INTEGER" data-translate="publicGatewayApp.ProfileCriterionType.INTEGER">INTEGER</option><option value="FLOAT" data-translate="publicGatewayApp.ProfileCriterionType.FLOAT">FLOAT</option><option value="DOUBLE" data-translate="publicGatewayApp.ProfileCriterionType.DOUBLE">DOUBLE</option><option value="SINGLE_SELECT" data-translate="publicGatewayApp.ProfileCriterionType.SINGLE_SELECT">SINGLE_SELECT</option><option value="MULTI_SELECT" data-translate="publicGatewayApp.ProfileCriterionType.MULTI_SELECT">MULTI_SELECT</option></select></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.profileCriterion.measurementUnitName" for="field_measurementUnitName">Measurement Unit Name</label><input type="text" class="form-control" name="measurementUnitName" id="field_measurementUnitName" ng-model="vm.profileCriterion.measurementUnitName"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/profile-criterion-item/profile-criterion-item-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.profileCriterionItem.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="publicGatewayApp.profileCriterionItem.delete.question" translate-values="{id: \'{{vm.profileCriterionItem.id}}\'}">Are you sure you want to delete this Profile Criterion Item?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/profile-criterion-item/profile-criterion-item-detail.html','<div><h2><span data-translate="publicGatewayApp.profileCriterionItem.detail.title">Profile Criterion Item</span> {{vm.profileCriterionItem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="publicGatewayApp.profileCriterionItem.name">Name</span></dt><dd><span>{{vm.profileCriterionItem.name}}</span></dd><dt><span data-translate="publicGatewayApp.profileCriterionItem.shortName">Short Name</span></dt><dd><span>{{vm.profileCriterionItem.shortName}}</span></dd><dt><span data-translate="publicGatewayApp.profileCriterionItem.sortOrder">Sort Order</span></dt><dd><span>{{vm.profileCriterionItem.sortOrder}}</span></dd><dt><span data-translate="publicGatewayApp.profileCriterionItem.enable">Enable</span></dt><dd><span>{{vm.profileCriterionItem.enable}}</span></dd><dt><span data-translate="publicGatewayApp.profileCriterionItem.profileCriterion">Profile Criterion</span></dt><dd><a ui-sref="profile-criterion-detail({id:vm.profileCriterionItem.profileCriterion.id})">{{vm.profileCriterionItem.profileCriterion.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="profile-criterion-item-detail.edit({id:vm.profileCriterionItem.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/profile-criterion-item/profile-criterion-item-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProfileCriterionItemLabel" data-translate="publicGatewayApp.profileCriterionItem.home.createOrEditLabel">Create or edit a Profile Criterion Item</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.profileCriterionItem.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.profileCriterionItem.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.profileCriterionItem.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.profileCriterionItem.name" required ng-minlength="1" ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.profileCriterionItem.shortName" for="field_shortName">Short Name</label><input type="text" class="form-control" name="shortName" id="field_shortName" ng-model="vm.profileCriterionItem.shortName" required ng-minlength="1" ng-maxlength="32"><div ng-show="editForm.shortName.$invalid"><p class="help-block" ng-show="editForm.shortName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.shortName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.shortName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.profileCriterionItem.sortOrder" for="field_sortOrder">Sort Order</label><input type="number" class="form-control" name="sortOrder" id="field_sortOrder" ng-model="vm.profileCriterionItem.sortOrder"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.profileCriterionItem.enable" for="field_enable">Enable</label><input type="checkbox" class="form-control" name="enable" id="field_enable" ng-model="vm.profileCriterionItem.enable"></div><div class="form-group"><label data-translate="publicGatewayApp.profileCriterionItem.profileCriterion" for="field_profileCriterion">Profile Criterion</label><select class="form-control" id="field_profileCriterion" name="profileCriterion" ng-model="vm.profileCriterionItem.profileCriterion" ng-options="profileCriterion as profileCriterion.id for profileCriterion in vm.profilecriteria track by profileCriterion.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/profile-criterion-item/profile-criterion-items.html','<div><h2 data-translate="publicGatewayApp.profileCriterionItem.home.title">Profile Criterion Items</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="profile-criterion-item.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="publicGatewayApp.profileCriterionItem.home.createLabel">Create new Profile Criterion Item</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'publicGatewayApp.profileCriterionItem.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="publicGatewayApp.profileCriterionItem.name">Name</span></th><th><span data-translate="publicGatewayApp.profileCriterionItem.shortName">Short Name</span></th><th><span data-translate="publicGatewayApp.profileCriterionItem.sortOrder">Sort Order</span></th><th><span data-translate="publicGatewayApp.profileCriterionItem.enable">Enable</span></th><th><span data-translate="publicGatewayApp.profileCriterionItem.profileCriterion">Profile Criterion</span></th><th></th></tr></thead><tbody><tr ng-repeat="profileCriterionItem in vm.profileCriterionItems track by profileCriterionItem.id"><td><a ui-sref="profile-criterion-item-detail({id:profileCriterionItem.id})">{{profileCriterionItem.id}}</a></td><td>{{profileCriterionItem.name}}</td><td>{{profileCriterionItem.shortName}}</td><td>{{profileCriterionItem.sortOrder}}</td><td>{{profileCriterionItem.enable}}</td><td><a ui-sref="profile-criterion-detail({id:profileCriterionItem.profileCriterion.id})">{{profileCriterionItem.profileCriterion.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="profile-criterion-item-detail({id:profileCriterionItem.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="profile-criterion-item.edit({id:profileCriterionItem.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="profile-criterion-item.delete({id:profileCriterionItem.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/public-profile/public-profile-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.publicProfile.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="publicGatewayApp.publicProfile.delete.question" translate-values="{id: \'{{vm.publicProfile.id}}\'}">Are you sure you want to delete this Public Profile?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/public-profile/public-profile-detail.html','<div><h2><span data-translate="publicGatewayApp.publicProfile.detail.title">Public Profile</span> {{vm.publicProfile.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="publicGatewayApp.publicProfile.version">Version</span></dt><dd><span>{{vm.publicProfile.version}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.login">Login</span></dt><dd><span>{{vm.publicProfile.login}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.title">Title</span></dt><dd><span>{{vm.publicProfile.title}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.screenName">Screen Name</span></dt><dd><span>{{vm.publicProfile.screenName}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.screenNameStatus">Screen Name Status</span></dt><dd><span>{{vm.publicProfile.screenNameStatus}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.description">Description</span></dt><dd><span>{{vm.publicProfile.description}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.descriptionStatus">Description Status</span></dt><dd><span>{{vm.publicProfile.descriptionStatus}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.genderEnum">Gender Enum</span></dt><dd><span>{{vm.publicProfile.genderEnum}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.age">Age</span></dt><dd><span>{{vm.publicProfile.age}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.avatar">Avatar</span></dt><dd><div ng-if="vm.publicProfile.avatar"><a ng-click="vm.openFile(vm.publicProfile.avatarContentType, vm.publicProfile.avatar)"><img data-ng-src="{{\'data:\' + vm.publicProfile.avatarContentType + \';base64,\' + vm.publicProfile.avatar}}" style="max-width: 100%" alt="publicProfile image"> </a>{{vm.publicProfile.avatarContentType}}, {{vm.byteSize(vm.publicProfile.avatar)}}</div></dd><dt><span data-translate="publicGatewayApp.publicProfile.originalUri">Original Uri</span></dt><dd><span>{{vm.publicProfile.originalUri}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.largeUri">Large Uri</span></dt><dd><span>{{vm.publicProfile.largeUri}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.mediumUri">Medium Uri</span></dt><dd><span>{{vm.publicProfile.mediumUri}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.smallUri">Small Uri</span></dt><dd><span>{{vm.publicProfile.smallUri}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.thumbnailUri">Thumbnail Uri</span></dt><dd><span>{{vm.publicProfile.thumbnailUri}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.photoCount">Photo Count</span></dt><dd><span>{{vm.publicProfile.photoCount}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.videoCount">Video Count</span></dt><dd><span>{{vm.publicProfile.videoCount}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.online">Online</span></dt><dd><span>{{vm.publicProfile.online}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.lastOnline">Last Online</span></dt><dd><span>{{vm.publicProfile.lastOnline}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.status">Status</span></dt><dd><span>{{vm.publicProfile.status}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.emailValidated">Email Validated</span></dt><dd><span>{{vm.publicProfile.emailValidated}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.confirmed">Confirmed</span></dt><dd><span>{{vm.publicProfile.confirmed}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.paid">Paid</span></dt><dd><span>{{vm.publicProfile.paid}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.premium">Premium</span></dt><dd><span>{{vm.publicProfile.premium}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.interests">Interests</span></dt><dd><span>{{vm.publicProfile.interests}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.tags">Tags</span></dt><dd><span>{{vm.publicProfile.tags}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.preferredLanguage">Preferred Language</span></dt><dd><span>{{vm.publicProfile.preferredLanguage}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.spokenLanguages">Spoken Languages</span></dt><dd><span>{{vm.publicProfile.spokenLanguages}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.rating">Rating</span></dt><dd><span>{{vm.publicProfile.rating}}</span></dd><dt><span data-translate="publicGatewayApp.publicProfile.gender">Gender</span></dt><dd><a ui-sref="gender-detail({id:vm.publicProfile.gender.id})">{{vm.publicProfile.gender.id}}</a></dd><dt><span data-translate="publicGatewayApp.publicProfile.seekingGender">Seeking Gender</span></dt><dd><a ui-sref="seeking-gender-detail({id:vm.publicProfile.seekingGender.id})">{{vm.publicProfile.seekingGender.id}}</a></dd><dt><span data-translate="publicGatewayApp.publicProfile.country">Country</span></dt><dd><a ui-sref="country-detail({id:vm.publicProfile.country.id})">{{vm.publicProfile.country.id}}</a></dd><dt><span data-translate="publicGatewayApp.publicProfile.region">Region</span></dt><dd><a ui-sref="region-detail({id:vm.publicProfile.region.id})">{{vm.publicProfile.region.id}}</a></dd><dt><span data-translate="publicGatewayApp.publicProfile.city">City</span></dt><dd><a ui-sref="city-detail({id:vm.publicProfile.city.id})">{{vm.publicProfile.city.id}}</a></dd><dt><span data-translate="publicGatewayApp.publicProfile.seekingSettings">Seeking Settings</span></dt><dd><a ui-sref="seeking-settings-detail({id:vm.publicProfile.seekingSettings.id})">{{vm.publicProfile.seekingSettings.id}}</a></dd><dt><span data-translate="publicGatewayApp.publicProfile.photo2">Photo 2</span></dt><dd><span ng-repeat="photo2 in vm.publicProfile.photo2S"><a ui-sref="photo-detail({id: photo2.id})">{{photo2.id}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="public-profile-detail.edit({id:vm.publicProfile.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/public-profile/public-profile-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPublicProfileLabel" data-translate="publicGatewayApp.publicProfile.home.createOrEditLabel">Create or edit a Public Profile</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.publicProfile.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.publicProfile.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.version" for="field_version">Version</label><input type="number" class="form-control" name="version" id="field_version" ng-model="vm.publicProfile.version"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.login" for="field_login">Login</label><input type="text" class="form-control" name="login" id="field_login" ng-model="vm.publicProfile.login" required ng-minlength="5" ng-maxlength="32"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 5 characters.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.publicProfile.title" required ng-minlength="1" ng-maxlength="10"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.title.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.title.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.screenName" for="field_screenName">Screen Name</label><input type="text" class="form-control" name="screenName" id="field_screenName" ng-model="vm.publicProfile.screenName" required ng-minlength="5" ng-maxlength="32"><div ng-show="editForm.screenName.$invalid"><p class="help-block" ng-show="editForm.screenName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.screenName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 5 characters.</p><p class="help-block" ng-show="editForm.screenName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.screenNameStatus" for="field_screenNameStatus">Screen Name Status</label><input type="number" class="form-control" name="screenNameStatus" id="field_screenNameStatus" ng-model="vm.publicProfile.screenNameStatus"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.publicProfile.description" required ng-minlength="10" ng-maxlength="10240"><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.description.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="10">This field is required to be at least 10 characters.</p><p class="help-block" ng-show="editForm.description.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10240">This field cannot be longer than 10240 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.descriptionStatus" for="field_descriptionStatus">Description Status</label><input type="number" class="form-control" name="descriptionStatus" id="field_descriptionStatus" ng-model="vm.publicProfile.descriptionStatus"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.genderEnum" for="field_genderEnum">Gender Enum</label><input type="number" class="form-control" name="genderEnum" id="field_genderEnum" ng-model="vm.publicProfile.genderEnum"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.age" for="field_age">Age</label><input type="number" class="form-control" name="age" id="field_age" ng-model="vm.publicProfile.age" required min="18" max="99"><div ng-show="editForm.age.$invalid"><p class="help-block" ng-show="editForm.age.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.age.$error.min" data-translate="entity.validation.min" translate-value-min="18">This field should be more than 18.</p><p class="help-block" ng-show="editForm.age.$error.max" data-translate="entity.validation.max" translate-value-max="99">This field cannot be more than 99.</p><p class="help-block" ng-show="editForm.age.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setAvatar($file, vm.publicProfile)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="publicGatewayApp.publicProfile.avatar" for="field_avatar">Avatar</label><div><img data-ng-src="{{\'data:\' + vm.publicProfile.avatarContentType + \';base64,\' + vm.publicProfile.avatar}}" style="max-height: 100px" ng-if="vm.publicProfile.avatar" alt="publicProfile image"><div ng-if="vm.publicProfile.avatar" class="help-block clearfix"><span class="pull-left">{{vm.publicProfile.avatarContentType}}, {{vm.byteSize(vm.publicProfile.avatar)}}</span> <button type="button" ng-click="vm.publicProfile.avatar=null;vm.publicProfile.avatarContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setAvatar($file, vm.publicProfile)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="avatar" id="field_avatar" ng-model="vm.publicProfile.avatar"> <input type="hidden" class="form-control" name="avatarContentType" id="field_avatarContentType" ng-model="vm.publicProfile.avatarContentType"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.originalUri" for="field_originalUri">Original Uri</label><input type="text" class="form-control" name="originalUri" id="field_originalUri" ng-model="vm.publicProfile.originalUri"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.largeUri" for="field_largeUri">Large Uri</label><input type="text" class="form-control" name="largeUri" id="field_largeUri" ng-model="vm.publicProfile.largeUri"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.mediumUri" for="field_mediumUri">Medium Uri</label><input type="text" class="form-control" name="mediumUri" id="field_mediumUri" ng-model="vm.publicProfile.mediumUri"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.smallUri" for="field_smallUri">Small Uri</label><input type="text" class="form-control" name="smallUri" id="field_smallUri" ng-model="vm.publicProfile.smallUri"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.thumbnailUri" for="field_thumbnailUri">Thumbnail Uri</label><input type="text" class="form-control" name="thumbnailUri" id="field_thumbnailUri" ng-model="vm.publicProfile.thumbnailUri"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.photoCount" for="field_photoCount">Photo Count</label><input type="number" class="form-control" name="photoCount" id="field_photoCount" ng-model="vm.publicProfile.photoCount" min="0" max="100"><div ng-show="editForm.photoCount.$invalid"><p class="help-block" ng-show="editForm.photoCount.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="help-block" ng-show="editForm.photoCount.$error.max" data-translate="entity.validation.max" translate-value-max="100">This field cannot be more than 100.</p><p class="help-block" ng-show="editForm.photoCount.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.videoCount" for="field_videoCount">Video Count</label><input type="number" class="form-control" name="videoCount" id="field_videoCount" ng-model="vm.publicProfile.videoCount" min="0" max="100"><div ng-show="editForm.videoCount.$invalid"><p class="help-block" ng-show="editForm.videoCount.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="help-block" ng-show="editForm.videoCount.$error.max" data-translate="entity.validation.max" translate-value-max="100">This field cannot be more than 100.</p><p class="help-block" ng-show="editForm.videoCount.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.online" for="field_online">Online</label><input type="checkbox" class="form-control" name="online" id="field_online" ng-model="vm.publicProfile.online"><div ng-show="editForm.online.$invalid"><p class="help-block" ng-show="editForm.online.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.lastOnline" for="field_lastOnline">Last Online</label><input type="number" class="form-control" name="lastOnline" id="field_lastOnline" ng-model="vm.publicProfile.lastOnline"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.status" for="field_status">Status</label><input type="number" class="form-control" name="status" id="field_status" ng-model="vm.publicProfile.status"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.emailValidated" for="field_emailValidated">Email Validated</label><input type="checkbox" class="form-control" name="emailValidated" id="field_emailValidated" ng-model="vm.publicProfile.emailValidated"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.confirmed" for="field_confirmed">Confirmed</label><input type="checkbox" class="form-control" name="confirmed" id="field_confirmed" ng-model="vm.publicProfile.confirmed"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.paid" for="field_paid">Paid</label><input type="checkbox" class="form-control" name="paid" id="field_paid" ng-model="vm.publicProfile.paid"><div ng-show="editForm.paid.$invalid"><p class="help-block" ng-show="editForm.paid.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.premium" for="field_premium">Premium</label><input type="checkbox" class="form-control" name="premium" id="field_premium" ng-model="vm.publicProfile.premium"><div ng-show="editForm.premium.$invalid"><p class="help-block" ng-show="editForm.premium.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.interests" for="field_interests">Interests</label><input type="text" class="form-control" name="interests" id="field_interests" ng-model="vm.publicProfile.interests"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.tags" for="field_tags">Tags</label><input type="text" class="form-control" name="tags" id="field_tags" ng-model="vm.publicProfile.tags"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.preferredLanguage" for="field_preferredLanguage">Preferred Language</label><input type="text" class="form-control" name="preferredLanguage" id="field_preferredLanguage" ng-model="vm.publicProfile.preferredLanguage"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.spokenLanguages" for="field_spokenLanguages">Spoken Languages</label><input type="text" class="form-control" name="spokenLanguages" id="field_spokenLanguages" ng-model="vm.publicProfile.spokenLanguages"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.publicProfile.rating" for="field_rating">Rating</label><input type="number" class="form-control" name="rating" id="field_rating" ng-model="vm.publicProfile.rating"></div><div class="form-group"><label data-translate="publicGatewayApp.publicProfile.gender" for="field_gender">Gender</label><select class="form-control" id="field_gender" name="gender" ng-model="vm.publicProfile.gender" ng-options="gender as gender.id for gender in vm.genders track by gender.id"><option value=""></option></select></div><div class="form-group"><label data-translate="publicGatewayApp.publicProfile.seekingGender" for="field_seekingGender">Seeking Gender</label><select class="form-control" id="field_seekingGender" name="seekingGender" ng-model="vm.publicProfile.seekingGender" ng-options="seekingGender as seekingGender.id for seekingGender in vm.seekinggenders track by seekingGender.id"><option value=""></option></select></div><div class="form-group"><label data-translate="publicGatewayApp.publicProfile.country" for="field_country">Country</label><select class="form-control" id="field_country" name="country" ng-model="vm.publicProfile.country" ng-options="country as country.id for country in vm.countries track by country.id"><option value=""></option></select></div><div class="form-group"><label data-translate="publicGatewayApp.publicProfile.region" for="field_region">Region</label><select class="form-control" id="field_region" name="region" ng-model="vm.publicProfile.region" ng-options="region as region.id for region in vm.regions track by region.id"><option value=""></option></select></div><div class="form-group"><label data-translate="publicGatewayApp.publicProfile.city" for="field_city">City</label><select class="form-control" id="field_city" name="city" ng-model="vm.publicProfile.city" ng-options="city as city.id for city in vm.cities track by city.id"><option value=""></option></select></div><div class="form-group"><label data-translate="publicGatewayApp.publicProfile.seekingSettings" for="field_seekingSettings">Seeking Settings</label><select class="form-control" id="field_seekingSettings" name="seekingSettings" ng-model="vm.publicProfile.seekingSettings" ng-options="seekingSettings as seekingSettings.id for seekingSettings in vm.seekingsettings | orderBy:\'id\' track by seekingSettings.id"><option value=""></option></select></div><div class="form-group"><label data-translate="publicGatewayApp.publicProfile.photo2" for="field_photo2">Photo 2</label><select class="form-control" id="field_photo2" multiple="multiple" name="photo2" ng-model="vm.publicProfile.photo2S" ng-options="photo as photo.id for photo in vm.photos track by photo.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/public-profile/public-profiles.html','<div><h2 data-translate="publicGatewayApp.publicProfile.home.title">Public Profiles</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="public-profile.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="publicGatewayApp.publicProfile.home.createLabel">Create new Public Profile</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'publicGatewayApp.publicProfile.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="version"><span data-translate="publicGatewayApp.publicProfile.version">Version</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="publicGatewayApp.publicProfile.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span data-translate="publicGatewayApp.publicProfile.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="screenName"><span data-translate="publicGatewayApp.publicProfile.screenName">Screen Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="screenNameStatus"><span data-translate="publicGatewayApp.publicProfile.screenNameStatus">Screen Name Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span data-translate="publicGatewayApp.publicProfile.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descriptionStatus"><span data-translate="publicGatewayApp.publicProfile.descriptionStatus">Description Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="genderEnum"><span data-translate="publicGatewayApp.publicProfile.genderEnum">Gender Enum</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="age"><span data-translate="publicGatewayApp.publicProfile.age">Age</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="avatar"><span data-translate="publicGatewayApp.publicProfile.avatar">Avatar</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="originalUri"><span data-translate="publicGatewayApp.publicProfile.originalUri">Original Uri</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="largeUri"><span data-translate="publicGatewayApp.publicProfile.largeUri">Large Uri</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="mediumUri"><span data-translate="publicGatewayApp.publicProfile.mediumUri">Medium Uri</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="smallUri"><span data-translate="publicGatewayApp.publicProfile.smallUri">Small Uri</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="thumbnailUri"><span data-translate="publicGatewayApp.publicProfile.thumbnailUri">Thumbnail Uri</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="photoCount"><span data-translate="publicGatewayApp.publicProfile.photoCount">Photo Count</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="videoCount"><span data-translate="publicGatewayApp.publicProfile.videoCount">Video Count</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="online"><span data-translate="publicGatewayApp.publicProfile.online">Online</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastOnline"><span data-translate="publicGatewayApp.publicProfile.lastOnline">Last Online</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="publicGatewayApp.publicProfile.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="emailValidated"><span data-translate="publicGatewayApp.publicProfile.emailValidated">Email Validated</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="confirmed"><span data-translate="publicGatewayApp.publicProfile.confirmed">Confirmed</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="paid"><span data-translate="publicGatewayApp.publicProfile.paid">Paid</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="premium"><span data-translate="publicGatewayApp.publicProfile.premium">Premium</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="interests"><span data-translate="publicGatewayApp.publicProfile.interests">Interests</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tags"><span data-translate="publicGatewayApp.publicProfile.tags">Tags</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="preferredLanguage"><span data-translate="publicGatewayApp.publicProfile.preferredLanguage">Preferred Language</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="spokenLanguages"><span data-translate="publicGatewayApp.publicProfile.spokenLanguages">Spoken Languages</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="rating"><span data-translate="publicGatewayApp.publicProfile.rating">Rating</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="gender.id"><span data-translate="publicGatewayApp.publicProfile.gender">Gender</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="seekingGender.id"><span data-translate="publicGatewayApp.publicProfile.seekingGender">Seeking Gender</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="country.id"><span data-translate="publicGatewayApp.publicProfile.country">Country</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="region.id"><span data-translate="publicGatewayApp.publicProfile.region">Region</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="city.id"><span data-translate="publicGatewayApp.publicProfile.city">City</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="seekingSettings.id"><span data-translate="publicGatewayApp.publicProfile.seekingSettings">Seeking Settings</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="publicProfile in vm.publicProfiles track by publicProfile.id"><td><a ui-sref="public-profile-detail({id:publicProfile.id})">{{publicProfile.id}}</a></td><td>{{publicProfile.version}}</td><td>{{publicProfile.login}}</td><td>{{publicProfile.title}}</td><td>{{publicProfile.screenName}}</td><td>{{publicProfile.screenNameStatus}}</td><td>{{publicProfile.description}}</td><td>{{publicProfile.descriptionStatus}}</td><td>{{publicProfile.genderEnum}}</td><td>{{publicProfile.age}}</td><td><a ng-if="publicProfile.avatar" ng-click="vm.openFile(publicProfile.avatarContentType, publicProfile.avatar)"><img data-ng-src="{{\'data:\' + publicProfile.avatarContentType + \';base64,\' + publicProfile.avatar}}" style="max-height: 30px" alt="publicProfile image"> </a><span ng-if="publicProfile.avatar">{{publicProfile.avatarContentType}}, {{vm.byteSize(publicProfile.avatar)}}</span></td><td>{{publicProfile.originalUri}}</td><td>{{publicProfile.largeUri}}</td><td>{{publicProfile.mediumUri}}</td><td>{{publicProfile.smallUri}}</td><td>{{publicProfile.thumbnailUri}}</td><td>{{publicProfile.photoCount}}</td><td>{{publicProfile.videoCount}}</td><td>{{publicProfile.online}}</td><td>{{publicProfile.lastOnline}}</td><td>{{publicProfile.status}}</td><td>{{publicProfile.emailValidated}}</td><td>{{publicProfile.confirmed}}</td><td>{{publicProfile.paid}}</td><td>{{publicProfile.premium}}</td><td>{{publicProfile.interests}}</td><td>{{publicProfile.tags}}</td><td>{{publicProfile.preferredLanguage}}</td><td>{{publicProfile.spokenLanguages}}</td><td>{{publicProfile.rating}}</td><td><a ui-sref="gender-detail({id:publicProfile.gender.id})">{{publicProfile.gender.id}}</a></td><td><a ui-sref="seeking-gender-detail({id:publicProfile.seekingGender.id})">{{publicProfile.seekingGender.id}}</a></td><td><a ui-sref="country-detail({id:publicProfile.country.id})">{{publicProfile.country.id}}</a></td><td><a ui-sref="region-detail({id:publicProfile.region.id})">{{publicProfile.region.id}}</a></td><td><a ui-sref="city-detail({id:publicProfile.city.id})">{{publicProfile.city.id}}</a></td><td><a ui-sref="seeking-settings-detail({id:publicProfile.seekingSettings.id})">{{publicProfile.seekingSettings.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="public-profile-detail({id:publicProfile.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="public-profile.edit({id:publicProfile.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="public-profile.delete({id:publicProfile.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/region/region-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.region.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="publicGatewayApp.region.delete.question" translate-values="{id: \'{{vm.region.id}}\'}">Are you sure you want to delete this Region?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/region/region-detail.html','<div><h2><span data-translate="publicGatewayApp.region.detail.title">Region</span> {{vm.region.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="publicGatewayApp.region.geonameId">Geoname Id</span></dt><dd><span>{{vm.region.geonameId}}</span></dd><dt><span data-translate="publicGatewayApp.region.regionIsoCode">Region Iso Code</span></dt><dd><span>{{vm.region.regionIsoCode}}</span></dd><dt><span data-translate="publicGatewayApp.region.regionName">Region Name</span></dt><dd><span>{{vm.region.regionName}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="region-detail.edit({id:vm.region.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/region/region-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRegionLabel" data-translate="publicGatewayApp.region.home.createOrEditLabel">Create or edit a Region</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.region.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.region.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.region.geonameId" for="field_geonameId">Geoname Id</label><input type="number" class="form-control" name="geonameId" id="field_geonameId" ng-model="vm.region.geonameId"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.region.regionIsoCode" for="field_regionIsoCode">Region Iso Code</label><input type="text" class="form-control" name="regionIsoCode" id="field_regionIsoCode" ng-model="vm.region.regionIsoCode"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.region.regionName" for="field_regionName">Region Name</label><input type="text" class="form-control" name="regionName" id="field_regionName" ng-model="vm.region.regionName"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/region/regions.html','<div><h2 data-translate="publicGatewayApp.region.home.title">Regions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="region.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="publicGatewayApp.region.home.createLabel">Create new Region</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'publicGatewayApp.region.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="geonameId"><span data-translate="publicGatewayApp.region.geonameId">Geoname Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="regionIsoCode"><span data-translate="publicGatewayApp.region.regionIsoCode">Region Iso Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="regionName"><span data-translate="publicGatewayApp.region.regionName">Region Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="region in vm.regions track by region.id"><td><a ui-sref="region-detail({id:region.id})">{{region.id}}</a></td><td>{{region.geonameId}}</td><td>{{region.regionIsoCode}}</td><td>{{region.regionName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="region-detail({id:region.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="region.edit({id:region.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="region.delete({id:region.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/seeking-gender/seeking-gender-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.seekingGender.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="publicGatewayApp.seekingGender.delete.question" translate-values="{id: \'{{vm.seekingGender.id}}\'}">Are you sure you want to delete this Seeking Gender?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/seeking-gender/seeking-gender-detail.html','<div><h2><span data-translate="publicGatewayApp.seekingGender.detail.title">Seeking Gender</span> {{vm.seekingGender.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="publicGatewayApp.seekingGender.name">Name</span></dt><dd><span>{{vm.seekingGender.name}}</span></dd><dt><span data-translate="publicGatewayApp.seekingGender.shortName">Short Name</span></dt><dd><span>{{vm.seekingGender.shortName}}</span></dd><dt><span data-translate="publicGatewayApp.seekingGender.title">Title</span></dt><dd><span>{{vm.seekingGender.title}}</span></dd><dt><span data-translate="publicGatewayApp.seekingGender.sortOrder">Sort Order</span></dt><dd><span>{{vm.seekingGender.sortOrder}}</span></dd><dt><span data-translate="publicGatewayApp.seekingGender.enable">Enable</span></dt><dd><span>{{vm.seekingGender.enable}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="seeking-gender-detail.edit({id:vm.seekingGender.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/seeking-gender/seeking-gender-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySeekingGenderLabel" data-translate="publicGatewayApp.seekingGender.home.createOrEditLabel">Create or edit a Seeking Gender</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.seekingGender.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.seekingGender.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.seekingGender.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.seekingGender.name" required ng-minlength="1" ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.seekingGender.shortName" for="field_shortName">Short Name</label><input type="text" class="form-control" name="shortName" id="field_shortName" ng-model="vm.seekingGender.shortName" required ng-minlength="1" ng-maxlength="32"><div ng-show="editForm.shortName.$invalid"><p class="help-block" ng-show="editForm.shortName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.shortName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.shortName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.seekingGender.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.seekingGender.title" required ng-minlength="1" ng-maxlength="32"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.title.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.title.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.seekingGender.sortOrder" for="field_sortOrder">Sort Order</label><input type="number" class="form-control" name="sortOrder" id="field_sortOrder" ng-model="vm.seekingGender.sortOrder"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.seekingGender.enable" for="field_enable">Enable</label><input type="checkbox" class="form-control" name="enable" id="field_enable" ng-model="vm.seekingGender.enable"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/seeking-gender/seeking-genders.html','<div><h2 data-translate="publicGatewayApp.seekingGender.home.title">Seeking Genders</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="seeking-gender.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="publicGatewayApp.seekingGender.home.createLabel">Create new Seeking Gender</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'publicGatewayApp.seekingGender.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="publicGatewayApp.seekingGender.name">Name</span></th><th><span data-translate="publicGatewayApp.seekingGender.shortName">Short Name</span></th><th><span data-translate="publicGatewayApp.seekingGender.title">Title</span></th><th><span data-translate="publicGatewayApp.seekingGender.sortOrder">Sort Order</span></th><th><span data-translate="publicGatewayApp.seekingGender.enable">Enable</span></th><th></th></tr></thead><tbody><tr ng-repeat="seekingGender in vm.seekingGenders track by seekingGender.id"><td><a ui-sref="seeking-gender-detail({id:seekingGender.id})">{{seekingGender.id}}</a></td><td>{{seekingGender.name}}</td><td>{{seekingGender.shortName}}</td><td>{{seekingGender.title}}</td><td>{{seekingGender.sortOrder}}</td><td>{{seekingGender.enable}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="seeking-gender-detail({id:seekingGender.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="seeking-gender.edit({id:seekingGender.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="seeking-gender.delete({id:seekingGender.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/seeking-settings/seeking-settings-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.seekingSettings.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="publicGatewayApp.seekingSettings.delete.question" translate-values="{id: \'{{vm.seekingSettings.id}}\'}">Are you sure you want to delete this Seeking Settings?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/seeking-settings/seeking-settings-detail.html','<div><h2><span data-translate="publicGatewayApp.seekingSettings.detail.title">Seeking Settings</span> {{vm.seekingSettings.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="publicGatewayApp.seekingSettings.ageFrom">Age From</span></dt><dd><span>{{vm.seekingSettings.ageFrom}}</span></dd><dt><span data-translate="publicGatewayApp.seekingSettings.ageTo">Age To</span></dt><dd><span>{{vm.seekingSettings.ageTo}}</span></dd><dt><span data-translate="publicGatewayApp.seekingSettings.onlyFromMyMatches">Only From My Matches</span></dt><dd><span>{{vm.seekingSettings.onlyFromMyMatches}}</span></dd><dt><span data-translate="publicGatewayApp.seekingSettings.genderSet">Gender Set</span></dt><dd><span>{{vm.seekingSettings.genderSet}}</span></dd><dt><span data-translate="publicGatewayApp.seekingSettings.gender">Gender</span></dt><dd><span ng-repeat="gender in vm.seekingSettings.genders"><a ui-sref="gender-enum-detail({id: gender.id})">{{gender.id}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="seeking-settings-detail.edit({id:vm.seekingSettings.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/seeking-settings/seeking-settings-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySeekingSettingsLabel" data-translate="publicGatewayApp.seekingSettings.home.createOrEditLabel">Create or edit a Seeking Settings</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.seekingSettings.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.seekingSettings.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.seekingSettings.ageFrom" for="field_ageFrom">Age From</label><input type="number" class="form-control" name="ageFrom" id="field_ageFrom" ng-model="vm.seekingSettings.ageFrom" min="18" max="100"><div ng-show="editForm.ageFrom.$invalid"><p class="help-block" ng-show="editForm.ageFrom.$error.min" data-translate="entity.validation.min" translate-value-min="18">This field should be more than 18.</p><p class="help-block" ng-show="editForm.ageFrom.$error.max" data-translate="entity.validation.max" translate-value-max="100">This field cannot be more than 100.</p><p class="help-block" ng-show="editForm.ageFrom.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.seekingSettings.ageTo" for="field_ageTo">Age To</label><input type="number" class="form-control" name="ageTo" id="field_ageTo" ng-model="vm.seekingSettings.ageTo" required min="18" max="100"><div ng-show="editForm.ageTo.$invalid"><p class="help-block" ng-show="editForm.ageTo.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.ageTo.$error.min" data-translate="entity.validation.min" translate-value-min="18">This field should be more than 18.</p><p class="help-block" ng-show="editForm.ageTo.$error.max" data-translate="entity.validation.max" translate-value-max="100">This field cannot be more than 100.</p><p class="help-block" ng-show="editForm.ageTo.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.seekingSettings.onlyFromMyMatches" for="field_onlyFromMyMatches">Only From My Matches</label><input type="checkbox" class="form-control" name="onlyFromMyMatches" id="field_onlyFromMyMatches" ng-model="vm.seekingSettings.onlyFromMyMatches"></div><div class="form-group"><label class="control-label" data-translate="publicGatewayApp.seekingSettings.genderSet" for="field_genderSet">Gender Set</label><input type="number" class="form-control" name="genderSet" id="field_genderSet" ng-model="vm.seekingSettings.genderSet"></div><div class="form-group"><label data-translate="publicGatewayApp.seekingSettings.gender" for="field_gender">Gender</label><select class="form-control" id="field_gender" multiple="multiple" name="gender" ng-model="vm.seekingSettings.genders" ng-options="genderEnum as genderEnum.id for genderEnum in vm.genderenums track by genderEnum.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/seeking-settings/seeking-settings.html','<div><h2 data-translate="publicGatewayApp.seekingSettings.home.title">Seeking Settings</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="seeking-settings.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="publicGatewayApp.seekingSettings.home.createLabel">Create new Seeking Settings</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'publicGatewayApp.seekingSettings.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ageFrom"><span data-translate="publicGatewayApp.seekingSettings.ageFrom">Age From</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ageTo"><span data-translate="publicGatewayApp.seekingSettings.ageTo">Age To</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="onlyFromMyMatches"><span data-translate="publicGatewayApp.seekingSettings.onlyFromMyMatches">Only From My Matches</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="genderSet"><span data-translate="publicGatewayApp.seekingSettings.genderSet">Gender Set</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="seekingSettings in vm.seekingSettings track by seekingSettings.id"><td><a ui-sref="seeking-settings-detail({id:seekingSettings.id})">{{seekingSettings.id}}</a></td><td>{{seekingSettings.ageFrom}}</td><td>{{seekingSettings.ageTo}}</td><td>{{seekingSettings.onlyFromMyMatches}}</td><td>{{seekingSettings.genderSet}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="seeking-settings-detail({id:seekingSettings.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="seeking-settings.edit({id:seekingSettings.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="seeking-settings.delete({id:seekingSettings.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.http.403">You are not authorized to access this page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo-jhipster.png" alt="logo"> <span data-translate="global.title">PublicGateway</span> <span class="navbar-version">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="photo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.photo">Photo</span></a></li><li ui-sref-active="active"><a ui-sref="public-profile" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.publicProfile">Public Profile</span></a></li><li ui-sref-active="active"><a ui-sref="language" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.language">Language</span></a></li><li ui-sref-active="active"><a ui-sref="gender" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.gender">Gender</span></a></li><li ui-sref-active="active"><a ui-sref="seeking-gender" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.seekingGender">Seeking Gender</span></a></li><li ui-sref-active="active"><a ui-sref="city" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.city">City</span></a></li><li ui-sref-active="active"><a ui-sref="country" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.country">Country</span></a></li><li ui-sref-active="active"><a ui-sref="region" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.region">Region</span></a></li><li ui-sref-active="active"><a ui-sref="location" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.location">Location</span></a></li><li ui-sref-active="active"><a ui-sref="seeking-settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.seekingSettings">Seeking Settings</span></a></li><li ui-sref-active="active"><a ui-sref="profile-criterion" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.profileCriterion">Profile Criterion</span></a></li><li ui-sref-active="active"><a ui-sref="profile-criterion-item" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.profileCriterionItem">Profile Criterion Item</span></a></li><li ui-sref-active="active"><a ui-sref="geoname-localization" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.geonameLocalization">Geoname Localization</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span data-translate="global.menu.account.register">Register</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="gateway" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-road"></span>&nbsp; <span data-translate="global.menu.admin.gateway">Gateway</span></a></li><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-tracker" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-eye-open"></span>&nbsp; <span data-translate="global.menu.admin.tracker">User tracker</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --><li ng-hide="vm.inProduction"><a href="/h2-console" target="_tab" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-hdd"></span>&nbsp; <span data-translate="global.menu.admin.database">Database</span></a></li></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>Email address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the email address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success === \'OK\'"><p data-translate="reset.request.messages.success">Check your emails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');
$templateCache.put('app/account/social/directive/social.html','<form action="{{ providerURL }}" method="POST"><button type="submit" class="btn btn-block jh-btn-social jh-btn-{{ provider }}"><span data-translate="social.btnLabel" translate-values="{ label: label }">Sign in with {{ label }}</span></button> <input name="scope" type="hidden" value="{{\xA0providerSetting }}"> <input name="_csrf" type="hidden" value="{{\xA0csrf }}"></form>');}]);})();